(function () {
  class FirelinkFeature extends PIXI.Container {
    constructor() {
      super();

      this._reels = [];
      this._stormLinkReels = [];
      this._freeSpinsReels = [];
      this._reelPrizeObjects = [];
      this._inFS = false;
      this._currentSpinPositions = [];
      this._currentBaseGameSymbols = [];
      this._prizes = [];
      this._reelstopIdx = 0;
      this._active = false;

      this.reelsToUnlock = [];

      this._fireBallIntro = undefined;
      this._fireballLinkStartData = undefined;
      this._fireballLinkStartTask = undefined;
      this._endEvent = undefined;

      this._skipped = false;

      this._reelsTimer = undefined;

      this._endTaskWinnings = 0;
      this._blazingLogoPosition = { topY: -106, midY: 0 };

      this._megaPotValue = 0;
      this._megaPotWon = false;
      this._megaPotResetValue = 0;

      this.events = [];
      this.afterEventsProcessedCallback = undefined;
      this.blazingHotZones = [false, false, false, false, false, false];
      this.fireballsPartOfBlazingbountyMerge = [];
      this.doneBBActivateAnimations = false;
      this.fireballsPartOfExtraHot = [];
      this.doneExtraHotActivateAnimations = false;
      this.doneRespinPlusActivateAnimations = false;
      this.livesMaximum = 0;
      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe(
        "8bofBB:FireballLinkStartEvent",
        this.onfireballLinkStartEvent.bind(this)
      );
      messageBus.subscribe(
        "8bof:FireballLinkDataEvent",
        this.onfireballLinkDataEvent.bind(this)
      );
      messageBus.subscribe(
        "8bof:FireballLinkDataEventDead",
        this.onfireballLinkDataEventDead.bind(this)
      );
      messageBus.subscribe(
        "8bof:FireballLinkEndEvent",
        this.onfireballLinkEndEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsStartEvent",
        this.onFreespinsStart.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsEndEvent",
        this.onFreespinsEndEvent.bind(this)
      );
      messageBus.subscribe("spinner:SpinEvent", this.onSpin.bind(this));
      messageBus.subscribe(
        "stake:stakeChanged",
        this.onStakeChanged.bind(this)
      );
      Reflex.registerEventHandler(
        "layoutChange",
        this.onOrientationChange.bind(this)
      );
    }

    onOrientationChange() {
      if (this._active) {
        if (this._logo) {
          this._logo.visible = false;
        }
        //this._winlinesTab.visible = false;
      }
    }

    onStakeChanged(stake) {
      if (stake === undefined) {
        return;
      }

      let goldenBetButton = resourceManager.get("goldenBetToggleButton");
      if (
        goldenBetButton !== undefined &&
        goldenBetButton._flags.showGoldenBetActive
      ) {
        goldenBetButton.glow.visible = false;
        stake = stake / gameData.goldenBetMultiplier;
      }
    }

    findChild(parent, name) {
      const child = parent.find(function (child) {
        return child.Props.ID === name;
      });
      return child;
    }

    onGameConfigEvent() {
      const self = this;

      this.infoPanel = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:InfoPanel"
      );

      this.infoPanel.visible = false;

      this._reelFrame = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkReelFrame"
      );
      this._reelFrame.visible = false;

      this._slotMachine = resourceManager.getController("SlotMachine0_0");
      for (let reel = 0; reel < gameData.numReels; ++reel) {
        let rows = [];
        let freeSpinRows = [];
        let stormLinkRows = [];
        this._reelPrizeObjects.push([]);
        for (let row = 0; row < gameData.numRows; ++row) {
          const id = reel * gameData.numRows + row;
          const rv = resourceManager.get(
            "slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup" +
              reel +
              ":reel" +
              id
          );
          rv.reassignSlotMachine(this._slotMachine);
          rows.push(rv);

          const stormLinkReel = resourceManager.get(
            "slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup" +
              reel +
              ":reel" +
              id +
              ":symbol0:symbol:childContainer:fireballCashOverlay"
          );
          stormLinkRows.push(stormLinkReel);

          const freeSpinReel = resourceManager.get(
            "slotContainer:reelContainer:reel" +
              reel +
              ":symbol" +
              row +
              ":symbol_standard:childContainer:fireballCashOverlay"
          );
          freeSpinRows.push(freeSpinReel);

          const prizeContainer = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id
          );
          prizeContainer.visible = false;
          prizeContainer.position = rv.position;

          const value = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":value"
          );
          value.visible = false;

          const mini = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":mini"
          );
          mini.visible = false;

          const mini_double = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":mini_double"
          );
          mini_double.visible = false;

          const minor = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":minor"
          );
          minor.visible = false;

          const minor_double = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":minor_double"
          );
          minor_double.visible = false;

          const major = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":major"
          );
          major.visible = false;

          const major_double = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":major_double"
          );
          major_double.visible = false;

          const mega = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":mega"
          );
          mega.visible = false;

          const mega_double = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":mega_double"
          );
          mega_double.visible = false;

          this._reelPrizeObjects[reel].push({
            container: prizeContainer,
            text: value,
            mini,
            minor,
            major,
            mega,
            mini_double,
            minor_double,
            major_double,
            mega_double,
          });
        }
        this._reels.push(rows);
        this._stormLinkReels.push(stormLinkRows);
        this._freeSpinsReels.push(freeSpinRows);
      }

      const coinContainer = resourceManager.get(
        "slotContainer:firelinkPrizes:coinContainer"
      );
      this._coinGroup1 = [];

      for (let i = 0; i < 100; i++) {
        // amount of coins to createq
        const randNum = Math.floor(Math.random() * (12 - 0 + 1)) + 1; //there are 13 different coin images
        let coin;

        if (randNum > 9) {
          coin = new PIXI.Sprite.fromImage(
            ReflexLoader.rootResDir + `Particles/Coin/Coin_000${randNum}.png`
          );
        } else {
          coin = new PIXI.Sprite.fromImage(
            ReflexLoader.rootResDir + `Particles/Coin/Coin_0000${randNum}.png`
          );
        }
        coinContainer.addChild(coin);
        coin.visible = false;

        // if (i > 40) {
        this._coinGroup1.push(coin);
        // } else {
        //   this._coinGroup2.push(coin);
        // }
      }

      this._slotMachine.selectReelMode("default");

      this._slotMachine.subscribeToReelsLandedEvent(function (reelId) {
        self.onSpinLand(reelId);
      });

      this._lives = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:lives"
      );

      this._livesTextLabel = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:livesText"
      );

      //TODO: HB Keeping this incase it comes back
      // this._collectedText = resourceManager.get(
      // 	"slotContainer:firelinkFeatureContainer:firelinkFeature:collected"
      // );

      this._winningsPanel = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:moneyPanel"
      );
      this._winningsPanel.visible = false;
      this._winningsTextContainer = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:moneyPanel:winningsContainer"
      );

      this._winningsText = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:moneyPanel:winningsContainer:winnings"
      );

      this._fireBallIntro = resourceManager.get(
        "slotContainer:fireballIntroPopup:fireballIntro"
      );

      this._linkBG = resourceManager.get(
        "baseGameBackground:landscapeBackground:nightBackground"
      );
      this._linkBG.visible = false;

      this._linkBGPortrait = resourceManager.get(
        "baseGameBackground:portraitBackground:nightBackground"
      );
      this._linkBGPortrait.visible = false;

      // this._winlinesTab = resourceManager.get(
      //   "slotContainer:reelFrame:winlinesTab"
      // );

      this._shaker = resourceManager.get("reelsShaker");

      this._fireballLandAnimator = resourceManager.get(
        "slotContainer:FireballLandAnimator"
      );

      this._megaValue = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:megaValue"
      );
      this._megaValue.visible = false;

      this.visible = false;

      this.blazingEndSequence = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:EndSequence"
      );
      this.blazingEndSequenceMaskContainer = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:EndSequence:MaskContainer"
      );
      this.blazingLogo = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:EndSequence:Blazing"
      );
      this.multiplierLogo = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:EndSequence:Multiplier"
      );
      this.multiplierContainer = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:EndSequence:MultiplierContainer"
      );
      this.multiplierValue = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:EndSequence:MultiplierContainer:multiplierValue"
      );
      this.blazingMovie = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:EndSequence:Blazing:BlazingTextBurn"
      );
      this.multiplierMovie = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:EndSequence:Multiplier:MultiplierTextBurn"
      );
      this.dimReels = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:dimReels"
      );

      const mask1 = new PIXI.Graphics();
      mask1.beginFill(0xff0000);
      mask1.drawRect(0, 0, 1, 1);
      mask1.endFill();
      mask1.scale.x = 895;
      mask1.scale.y = 892;

      this.blazingEndSequenceMaskContainer.addChild(mask1);
      this.blazingLogo.mask = mask1;
      this.multiplierLogo.mask = mask1;

      this.endingWinSequence = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:EndingWinSequence"
      );

      this.endingWinValue = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:EndingWinSequence:WinValueContrainer:WinValue"
      );

      this.endingWinValueContainer = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:EndingWinSequence:WinValueContrainer"
      );

      this.megaPotAward = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:JackpotAwardContainer:MegaPotTrailContainer"
      );
      this.megaPotAwardValue = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:JackpotAwardContainer:MegaPotTrailContainer:value"
      );
      this.rays = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:JackpotAwardContainer:Godrays"
      );

      for (let i = 0; i < this._slotMachine._reelVisuals.length; i++) {
        this._slotMachine._reelVisuals[i].suspendUpdates();
      }
    }

    onSpinLand(reelText) {
      let slotCount = +reelText.replace("reel", "");

      this.doLandAnimations(slotCount);

      // play landing sound - this is quiet against the theme music
      if (this._reelstopIdx === 6) {
        this._reelstopIdx = 0;
      }
      if (!this.slamStopped) {
        soundManager.play("reelStop" + this._reelstopIdx);
        this._reelstopIdx++;
      }

      // if reel that has landed is in the _newLockedReels array
      if (this._newLockedReels.includes(slotCount)) {
        // convert reel to reel/row
        let reel = Math.trunc(slotCount / gameData.numRows);
        let row = slotCount % gameData.numRows;
        const symbolInfo = resourceManager.getConfiguration().symbols;
        const symbolId = this._currentBaseGameSymbols[reel][row];

        this._reels[reel][row].bounceOverlays(0, symbolId);

        let soundIndex = Math.floor(Math.random() * 2);
        if (symbolId === symbolInfo["Symbol_FireballExtraHot"].ID) {
          soundManager.play("extraHotLand");
        } else if (symbolId === symbolInfo["Symbol_FireballRespinPlus"].ID) {
          soundManager.play("plusOneLand");
        } else if (symbolId === symbolInfo["Symbol_FireballBlazingBounty"].ID) {
          soundManager.play("blazingBountyLand");
        } else {
          if (!this.slamStopped) {
            soundManager.play(`fireBallLand${soundIndex}`);
          }
        }
      }
    }

    onSpin(task) {
      this._currentBaseGameSymbols = [];

      this._isWildFire = false; //task.data.isWildFire
      for (let reel = 0; reel < task.data.resultPanel.reelList.length; reel++) {
        this._currentBaseGameSymbols.push([]);
        for (
          let row = 0;
          row < task.data.resultPanel.reelList[reel].symbols.length;
          row++
        ) {
          this._currentBaseGameSymbols[reel].push(
            task.data.resultPanel.reelList[reel].symbols[row].value
          );
        }
      }
    }

    getNextSpinOutcome() {
      messageBus.post("spinner:stormLink");
      this._livesRemaining--;

      this.doneBBActivateAnimations = false;
      this.slamStopped = false;

      this.doneExtraHotActivateAnimations = false;
      this.doneRespinPlusActivateAnimations = false;
      this.fireballsPartOfBlazingbountyMerge = [];

      if (this._livesRemaining < 0) {
        messageBus.post("spinner:stormLinkEnd");
      }

      let livesVisible = this._livesRemaining > 0 ? true : false;

      this._livesTextLabel.visible = livesVisible;
      this._lives.visible = livesVisible;

      this.setLivesTranslation(this._livesRemaining);

      this._lives.text = this._livesRemaining;

      if (this._livesRemaining >= 0) {
        soundManager.play("lifeDown");
      }

      gdk.getNextGameOutcome(function () {});
    }

    setLivesTranslation(amountOfLives) {
      if (this._livesRemaining === 1) {
        this._livesTextLabel.setTranslationPhrase("t_live");
      } else {
        this._livesTextLabel.setTranslationPhrase("t_lives");
      }
    }

    processEvents() {
      //this.afterEventsProcessedCallback  << Set this so after events we know where to go.

      if (this.eventIndex === this.events.length) {
        //this.eventIndex = 0;
        //finishProcessingEvents;
        return this.finishProcessingEvents();
      } else if (this.eventIndex > this.events.length) {
        console.log(
          "Firelink Feature: Something event before this one is calling process events twice! This shouldn't happen but has been handled."
        );
        return;
      }
      soundManager.stop("reelSpin");
      if (this.events.length > 0) {
        const event = this.events[this.eventIndex];
        this.eventIndex++;
        switch (event.type) {
          case "BlazingBountyTransformToFireballEvent":
            this.processEvent_BlazingBountyTransformToFireballEvent(
              event,
              this.processEvents.bind(this)
            );
            break;
          case "BlazingMultiplierChangedEvent":
            this.processEvent_BlazingMultiplierChangedEvent(
              event,
              this.processEvents.bind(this)
            );
            break;
          case "BlazingZoneCreatedEvent":
            this.processEvent_BlazingZoneCreatedEvent(
              event,
              this.processEvents.bind(this)
            );
            break;
          case "BlazingZoneFireballMultiplierEvent":
            this.processEvent_BlazingZoneFireballMultiplierEvent(
              event,
              this.processEvents.bind(this)
            );
            break;
          case "BlazingZoneMergeEvent":
            this.processEvent_BlazingZoneMergeEvent(
              event,
              this.processEvents.bind(this)
            );
            break;
          case "LivesRemainingChangedEvent":
            this.processEvent_LivesRemainingChangedEvent(
              event,
              this.processEvents.bind(this)
            );
            break;
          case "MaximumLivesIncreasedEvent":
            this.processEvent_MaximumLivesIncreasedEvent(
              event,
              this.processEvents.bind(this)
            );
            break;
          case "MegaPotAwardedEvent":
            this.processEvent_MegaPotAwardedEvent(
              event,
              this.processEvents.bind(this)
            );
            break;
          case "ResetBlazingMultiplierEvent":
            this.processEvent_ResetBlazingMultiplierEvent(
              event,
              this.processEvents.bind(this)
            );
            break;
        }
      } else {
        console.log("NO FIREBALL LINK EVENTS!");
        this.finishProcessingEvents();
      }
    }

    finishProcessingEvents() {
      this.afterEventsProcessedCallback();
    }

    //==== FIRE BALL LINK EVENTS ====

    processEvent_BlazingBountyTransformToFireballEvent(event, cb) {
      // Occurs when a Blazing Bounty symbol transform into a Fireball.
      //   {
      //       "type": "BlazingBountyTransformToFireballEvent",
      //       "coord": {
      //           "reel": 2,
      //           "row": 0
      //       },
      //       "fireball": {
      //           "type": "Cash",
      //           "coord": {
      //               "reel": 2,
      //               "row": 0
      //           },
      //           "originalAmount": 80,
      //           "amount": 80
      //       }
      //   },
      const self = this;
      if (!this.doneBBActivateAnimations) {
        self.eventDoBBActivateAnimations(
          self.eventMoveTextOverToBBSymbol.bind(self, event, cb)
        );
      } else {
        self.eventMoveTextOverToBBSymbol(event, cb);
      }
    }

    moveJustMergedText(symbol, index, event, cb, self) {
      const fireBall = this.fireballsPartOfBlazingbountyMerge[index];
      const reelFireballTextIndex = convertReelRowToIndex(
        fireBall.coords.reel,
        fireBall.coords.row
      );
      const onReelsFireballText = resourceManager.get(
        `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${
          fireBall.coords.reel
        }:reel${reelFireballTextIndex}:symbol${0}:symbol:childContainer:fireballCashOverlay`
      );

      const textValue = onReelsFireballText.modifiedValue
        ? PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
            onReelsFireballText.modifiedValue / 100
          )
        : onReelsFireballText.text;

      gameController.reelFireballs[fireBall.coords.reel][
        fireBall.coords.row
      ].doBlazingBountyMergeCashValueTextMove(
        fireBall.symbol.position,
        symbol.position,
        textValue,
        function () {}
      );
    }

    movePreviouslyMergedText(symbol, reel, event, cb, self) {
      const reelFireballIndex = convertReelRowToIndex(reel, 2);
      const onReelsFireball = resourceManager.get(
        `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${reel}:reel${reelFireballIndex}`
      );
      const onReelsFireballText = resourceManager.get(
        `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${reel}:reel${reelFireballIndex}:symbol${0}:symbol:childContainer:fireballCashOverlay`
      );

      const textValue = onReelsFireballText.modifiedValue
        ? PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
            onReelsFireballText.modifiedValue / 100
          )
        : onReelsFireballText.text;

      gameController.reelFireballs[
        reel
      ][2].doBlazingBountyMergeCashValueTextMove(
        onReelsFireball.position,
        symbol.position,
        textValue,
        function () {}
      );
    }

    eventMoveTextOverToBBSymbol(event, cb) {
      const fireBallData = event.fireball;

      const fireballFeatureReelIndex = convertReelRowToIndex(
        fireBallData.coord.reel,
        fireBallData.coord.row
      );

      const symbol = resourceManager.get(
        `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${fireBallData.coord.reel}:reel${fireballFeatureReelIndex}`
      );

      this._numberOfFireballsToMerge =
        this.fireballsPartOfBlazingbountyMerge.length;
      const finalBlazingHotZone = this.blazingHotZones.findLastIndex(
        (reel) => reel === true
      );

      const self = this;

      if (this.fireballsPartOfBlazingbountyMerge.length) {
        const reelsWithNewlyMergedFireballs = [
          ...new Set(
            this.fireballsPartOfBlazingbountyMerge.map(
              (fireball) => fireball.coords.reel
            )
          ),
        ].sort((a, b) => a - b);
        const finalReelWithNewlyMergedFireball =
          reelsWithNewlyMergedFireballs[
            reelsWithNewlyMergedFireballs.length - 1
          ];
        const finalReelWithFireball = Math.max(
          finalBlazingHotZone,
          finalReelWithNewlyMergedFireball
        );
        for (let reel = 0; reel < this.blazingHotZones.length; reel++) {
          if (reelsWithNewlyMergedFireballs.includes(reel)) {
            const index = this.fireballsPartOfBlazingbountyMerge.findIndex(
              (fireball) => fireball.coords.reel === reel
            );
            this.moveJustMergedText(
              symbol,
              index,
              event,
              reel === finalReelWithFireball ? cb : () => {},
              self
            );
          } else if (this.blazingHotZones[reel]) {
            this.movePreviouslyMergedText(
              symbol,
              reel,
              event,
              reel === finalReelWithFireball ? cb : () => {},
              self
            );
          }
        }
      } else {
        let foundAHotzone = false;
        for (let reel = 0; reel < this.blazingHotZones.length; reel++) {
          const isHotzone = this.blazingHotZones[reel];
          if (isHotzone) {
            foundAHotzone = true;
            this.movePreviouslyMergedText(
              symbol,
              reel,
              event,
              reel === finalBlazingHotZone ? cb : () => {},
              self
            );
          }
        }
      }
      timerManager.addTimeout(
        400,
        self.eventTurnBBintoFireball.bind(self, event, cb)
      );
    }

    eventTurnBBintoFireball(event, cb) {
      const fireBallData = event.fireball;

      const fireballFeatureReelIndex = convertReelRowToIndex(
        fireBallData.coord.reel,
        fireBallData.coord.row
      );

      gameController.reelFireballs[fireBallData.coord.reel][
        fireBallData.coord.row
      ].visible = false;

      resourceManager
        .get(`slotContainer:reelContainer:reel${fireBallData.coord.reel}`)
        .setReelSymbol(fireBallData.coord.row, 19);

      const onReelsFireballText = resourceManager.get(
        `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${
          fireBallData.coord.reel
        }:reel${fireballFeatureReelIndex}:symbol${0}:symbol:childContainer:fireballCashOverlay`
      );

      const value = fireBallData.amount;

      onReelsFireballText.shouldNotBeSet = true;
      onReelsFireballText.setText(
        PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
          0
        )
      );
      onReelsFireballText.shouldBeHidden = false;
      onReelsFireballText.visible = true;

      const self = this;
      const symbol = resourceManager.get(
        `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${fireBallData.coord.reel}:reel${fireballFeatureReelIndex}`
      );

      symbol.setReelSymbol(0, 19);
      soundManager.play("blazingBountyCountUpStart");
      this.currentValue = 0;
      gsap.to(this, {
        currentValue: value,
        duration: 0.5,
        ease: "none",
        onUpdate: () => {
          onReelsFireballText.setText(
            PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
              this.currentValue / 100
            )
          );
          onReelsFireballText.modifiedValue = this.currentValue;
        },
        onComplete: () => {
          onReelsFireballText.setText(
            PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
              value / 100
            )
          );
          onReelsFireballText.modifiedValue = value;
          soundManager.stop("blazingBountyCountUpStart");
          soundManager.play("blazingBountyCountUpEnd");
          onReelsFireballText.shouldNotBeSet = false;
          self._reels[fireBallData.coord.reel][
            fireBallData.coord.row
          ].bounceOverlays();
        },
      });

      let found = false;

      for (let index = 0; index < this._prizes.length; index++) {
        const prize = this._prizes[index];
        if (
          prize.reel === fireBallData.coord.reel &&
          prize.row === fireBallData.coord.row
        ) {
          prize.prizeData.type = "Cash";
          prize.prizeData.value = value;
          prize.symbolId = 19;
          found = true;
          break;
        }
      }

      if (!found) {
        this._prizes.push({
          prizeData: {
            type: "Cash",
            value: value,
          },
          reel: fireBallData.coord.reel,
          row: fireBallData.coord.row,
          symbolId: 19,
        });
      }
      const lockedReelsIndex = this._lockedReels.indexOf(
        fireballFeatureReelIndex
      );
      if (lockedReelsIndex === -1) {
        this._lockedReels.push(fireballFeatureReelIndex);
      }
      this._currentSpinPositions[fireballFeatureReelIndex] = [19];

      timerManager.addTimeout(700, () => {
        gameController.reelFireballs[fireBallData.coord.reel][
          fireBallData.coord.row
        ].animateBlazingBounty(
          symbol.position,
          onReelsFireballText.text,
          self.doBlazingBountyPopup.bind(self, cb)
        );
      });
    }

    processEvent_BlazingMultiplierChangedEvent(event, cb) {
      // Occurs when the Blazing Multiplier is changed. I.e. Extra hot symbol!
      //   {
      //       "type": "BlazingMultiplierChangedEvent",
      //       "coord": {
      //           "reel": 0,
      //           "row": 0
      //       },
      //       "newMultiplier": 1,
      //       "newMultiplierId": "1"
      //   }

      const self = this;
      soundManager.play("extraHotTransition");
      if (!this.doneExtraHotActivateAnimations) {
        self.eventDoExtraHotActivateAnimations(
          self.eventMoveExtraHotSymbolToMultiplier.bind(self, event, cb)
        );
      } else {
        self.eventMoveExtraHotSymbolToMultiplier(event, cb);
      }
    }

    eventDoExtraHotActivateAnimations(functionAfter) {
      const self = this;

      this.numberOfExtraHotSymbols = 0;
      for (let index = 0; index < this._currentSpinPositions.length; index++) {
        const symId = this._currentSpinPositions[index][0];
        if (symId === 36) {
          this.numberOfExtraHotSymbols++;
          const reelRow = convertIndexToReelRow(index);

          const sym = resourceManager.get(
            `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${reelRow.reel}:reel${index}`
          );

          this.doneExtraHotActivateAnimations = true;
          gameController.reelFireballs[reelRow.reel][
            reelRow.row
          ].doExtraHotActivation(sym.position, function () {
            self.numberOfExtraHotSymbols--;
            if (self.numberOfExtraHotSymbols <= 0) {
              functionAfter();
            }
          });
        }
      }
    }

    eventMoveExtraHotSymbolToMultiplier(event, cb) {
      const self = this;

      const fireballFeatureReelIndex = convertReelRowToIndex(
        event.coord.reel,
        event.coord.row
      );

      const symbol = resourceManager.get(
        `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${event.coord.reel}:reel${fireballFeatureReelIndex}`
      );

      gameController.reelFireballs[event.coord.reel][
        event.coord.row
      ].doExtraHotMove(symbol.position, 100, function () {
        self.eventUpdateMultiplier(event, cb);
        gameController.blazingMultiplierFlame.visible = true;
        gameController.blazingMultiplierFlame.gotoAndStop(0);
        gameController.blazingMultiplierFlame.play();
        gameController.blazingMultiplierFlame.onComplete = () => {
          gameController.blazingMultiplierFlame.visible = false;
        };
      });
    }

    eventUpdateMultiplier(event, cb) {
      const self = this;
      const newMultiplierValue = parseFloat(event.newMultiplier);

      const fireballFeatureReelIndex = convertReelRowToIndex(
        event.coord.reel,
        event.coord.row
      );

      for (let index = 0; index < this._prizes.length; index++) {
        const prize = this._prizes[index];
        if (prize.reel === event.coord.reel && prize.row === event.coord.row) {
          this._prizes.splice(index, 1);
          break;
        }
      }

      const lockedReelsIndex = this._lockedReels.indexOf(
        fireballFeatureReelIndex
      );
      const newLockedReelsIndex = this._newLockedReels.indexOf(
        fireballFeatureReelIndex
      );
      if (lockedReelsIndex !== -1) {
        this._lockedReels.splice(lockedReelsIndex, 1);
      }
      if (newLockedReelsIndex !== -1) {
        this._newLockedReels.splice(newLockedReelsIndex, 1);
      }

      if (newMultiplierValue <= 5) {
        let animationName =
          "x" + gameController.currentBlazingMultiplier + " Up";
        animationName = animationName.replace(".", "_");
        gameController.currentBlazingMultiplier = newMultiplierValue;
        gameController.thermometer.play(
          animationName,
          false,
          0,
          this.finishPlayingThermoeterAnimation.bind(this, event, cb)
        );
      } else {
        let animationName = "x5";
        gameController.currentBlazingMultiplier = newMultiplierValue;
        gameController.thermometer.play(animationName, true, 0, undefined);
        timerManager.addTimeout(250, function () {
          self.finishPlayingThermoeterAnimation(event, cb);
        });
      }
    }

    finishPlayingThermoeterAnimation(event, cb) {
      let animationName = "x" + gameController.currentBlazingMultiplier;
      animationName = animationName.replace(".", "_");
      gameController.blazingMultiplierValue.setText(
        "X" + gameController.currentBlazingMultiplier
      );
      if (gameController.currentBlazingMultiplier <= 5) {
        gameController.thermometer.play(animationName, true, 0, undefined);
      }
      this.pulseBlazingMultiplierValue();
      timerManager.addTimeout(250, function () {
        cb();
      });
    }

    pulseBlazingMultiplierValue() {
      gsap
        .timeline()
        .to(gameController.blazingMultiplierValue.scale, {
          duration: 0.5,
          ease: "power1.in",
          y: 1.2,
          x: 1.2,
        })
        .to(gameController.blazingMultiplierValue.scale, {
          duration: 0.25,
          ease: "power1.in",
          y: 1,
          x: 1,
        });
    }

    processEvent_ResetBlazingMultiplierEvent(event, cb) {
      // Occurs when the Blazing Multiplier is reset. Note, we create this event on the client side. Coord is not used.
      //   {
      //       "type": "ResetBlazingMultiplierEvent",
      //       "coord": {
      //           "reel": 0,
      //           "row": 0
      //       },
      //       "newMultiplier": 1,
      //       "newMultiplierId": "1"
      //   }

      gameController.blazingMultiplierValue.setText("X" + event.newMultiplier);
      const newMultiplierValue = parseFloat(event.newMultiplier);

      if (gameController.currentBlazingMultiplier > 5) {
        let animationName = "Reset 5";
        animationName = animationName.replace(".", "_");
        gameController.currentBlazingMultiplier = newMultiplierValue;
        gameController.thermometer.play(animationName, false, 0, () => {
          gameController.thermometer.play("x1", true, 0, undefined);
        });
      } else if (gameController.currentBlazingMultiplier === 1) {
        let animationName = "x1";
        gameController.currentBlazingMultiplier = newMultiplierValue;
        gameController.thermometer.play(animationName, true, 0, undefined);
      } else {
        let animationName = "Reset " + gameController.currentBlazingMultiplier;
        animationName = animationName.replace(".", "_");
        gameController.currentBlazingMultiplier = newMultiplierValue;
        gameController.thermometer.play(animationName, false, 0, () => {
          gameController.thermometer.play("x1", true, 0, undefined);
        });
      }

      cb();
    }

    processEvent_BlazingZoneCreatedEvent(event, cb) {
      // Occurs when a Blazing Zone is created on a reel.
      //         {
      //             "type": "BlazingZoneCreatedEvent",
      //             "reel": 5
      //         }

      this.blazingHotZones[event.reel] = true;
      this[`blazingZone${event.reel}`].visible = true;
      this[`blazingZoneLoop${event.reel}`].visible = false;
      this[`blazingZoneGrow${event.reel}`].visible = true;
      this[`blazingZoneGrow${event.reel}`].gotoAndStop(0);
      this[`blazingZoneGrow${event.reel}`].play();
      this[`blazingZoneGrow${event.reel}`].onComplete = () => {
        this[`blazingZoneLoop${event.reel}`].visible = true;
        this[`blazingZoneLoop${event.reel}`].play();
        this[`blazingZoneGrow${event.reel}`].visible = false;
        const firstChild = resourceManager.get(
          `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${
            event.reel
          }:reel${event.reel * gameData.numRows}`
        );
        firstChild.useBlazingZoneMask();
      };
      soundManager.play("blazingBountyLock");
      cb();
    }

    processEvent_BlazingZoneFireballMultiplierEvent(event, cb) {
      // Occurs when all fireballs in blazing zones are multiplied.
      // The new amount is (oldAmount + (originalAmount * multiplier)).
      //   {
      //         "type": "BlazingZoneFireballMultiplierEvent",
      //         "multiplier": 0.1,
      //         "newFireballs": [
      //             {
      //                 "type": "Cash",
      //                 "coord": {
      //                     "reel": 1,
      //                     "row": 0
      //                 },
      //                 "originalAmount": 10,
      //                 "amount": 11
      //             },
      //         ]
      //     }

      const self = this;

      self.doBlazingMultiplierPopup(
        self.eventMultiplyFireballsInBlazingZone.bind(self, event, cb)
      );
    }

    eventMultiplyFireballsInBlazingZone(event, cb) {
      const multiplier = event.multiplier;

      for (let index = 0; index < event.newFireballs.length; index++) {
        const fireBallData = event.newFireballs[index];
        const orgValue = fireBallData.originalAmount;
        const value = fireBallData.amount;

        let found = false;

        for (let index = 0; index < this._prizes.length; index++) {
          const prize = this._prizes[index];
          if (
            prize.reel === fireBallData.coord.reel &&
            prize.row === fireBallData.coord.row
          ) {
            prize.prizeData.type = "Cash";
            prize.prizeData.value = value;
            prize.symbolId = 19;
            found = true;
            break;
          }
        }

        if (!found) {
          this._prizes.push({
            prizeData: {
              type: "Cash",
              value: value,
            },
            reel: fireBallData.coord.reel,
            row: fireBallData.coord.row,
            symbolId: this._currentSpinPositions[reelIndex][0],
          });
        }
      }

      const fireballs = [];
      for (let reel = 0; reel < gameData.numReels; reel++) {
        for (let row = 0; row < gameData.numRows; row++) {
          for (let i = 0; i < event.newFireballs.length; i++) {
            if (
              event.newFireballs[i].coord.reel === reel &&
              event.newFireballs[i].coord.row === row
            ) {
              fireballs.push(event.newFireballs[i]);
              break;
            }
          }
        }
      }

      const self = this;

      let zoneDelay = 0;
      let reelIdx = -1;
      for (let i = 0; i < fireballs.length; i++) {
        const fireBallData = fireballs[i];
        const orgValue = fireBallData.originalAmount;
        const value = fireBallData.amount;

        const fireballFeatureReelIndex = convertReelRowToIndex(
          fireBallData.coord.reel,
          fireBallData.coord.row
        );

        const onReelsFireball = resourceManager.get(
          `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${fireBallData.coord.reel}:reel${fireballFeatureReelIndex}:symbol0:symbol`
        );
        const onReelsFireballText = resourceManager.get(
          `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${
            fireBallData.coord.reel
          }:reel${fireballFeatureReelIndex}:symbol${0}:symbol:childContainer:fireballCashOverlay`
        );

        timerManager.addTimeout(zoneDelay, () => {
          gsap.to(onReelsFireball.scale, {
            x: 1.2,
            y: 1.2,
            duration: 0.5,
            yoyo: true,
            repeat: 1,
          });

          if (reelIdx != fireballs[i].coord.reel) {
            reelIdx = fireballs[i].coord.reel;
            soundManager.play("blazingBountyCountUpStart");
          }

          timerManager.addTimer(
            600,
            function (progress) {
              const val = Math.floor(orgValue + (value - orgValue) * progress);
              onReelsFireballText.setText(
                PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
                  val / 100
                )
              );
              onReelsFireballText.modifiedValue = val;
            },
            function () {
              onReelsFireballText.modifiedValue = value;
              onReelsFireballText.setText(
                PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
                  value / 100
                )
              );
              soundManager.stop("blazingBountyCountUpStart");
              soundManager.play("blazingBountyCountUpEnd");
              self._reels[fireBallData.coord.reel][
                fireBallData.coord.row
              ].bounceOverlays();
            }
          );
        });
        zoneDelay +=
          fireballs?.[i + 1]?.coord?.reel === fireBallData.coord.reel
            ? 0
            : 1000;
      }

      timerManager.addTimeout(
        1200 + zoneDelay,
        self.showWinningsPanel.bind(this, true, function () {
          self.processPrizes(function () {
            timerManager.addTimeout(800, function () {
              self.processMultipliers(function () {
                cb();
              });
            });
          });
        })
      );
    }

    processEvent_BlazingZoneMergeEvent(event, cb) {
      // Occurs when all fireballs in a blazing are merged into one fireball
      //  at the bottom of the reel.
      //     {
      //         "type": "BlazingZoneMergeEvent",
      //         "reel": 1,
      //         "newFireball": {
      //             "type": "Cash",
      //             "coord": {
      //                 "reel": 1,
      //                 "row": 2
      //             },
      //             "originalAmount": 44,
      //             "amount": 44
      //         }
      //     },

      const self = this;
      self.eventDoBBBlazingTextPulse(event);
      if (!this.doneBBActivateAnimations) {
        self.eventDoBBActivateAnimations(
          self.eventMergeSymbolsDownIntoBottomFireball.bind(self, event, cb)
        );
      } else {
        self.eventMergeSymbolsDownIntoBottomFireball(event, cb);
      }
    }

    eventDoBBBlazingTextPulse(event) {
      if (event.newFireball.coord.reel === 0) {
        this.blazingZoneText0.visible = true;
        gsap
          .timeline()
          .to(this.blazingZoneText0, {
            duration: 0.2,
            ease: "power1.inOut",
            alpha: 1,
          })
          .to(this.blazingZoneText0, {
            duration: 0.2,
            ease: "power1.inOut",
            alpha: 0,
            onComplete: () => {
              this.blazingZoneText0.visible = false;
            },
          });
        this.blazingZoneTextBurn0.visible = true;
        this.blazingZoneTextBurn0.gotoAndStop(0);
        this.blazingZoneTextBurn0.onComplete = () => {
          this.blazingZoneTextBurn0.visible = false;
        };
        this.blazingZoneTextBurn0.play();
      } else if (event.newFireball.coord.reel === 1) {
        this.blazingZoneText1.visible = true;
        gsap
          .timeline()
          .to(this.blazingZoneText1, {
            duration: 0.2,
            ease: "power1.inOut",
            alpha: 1,
          })
          .to(this.blazingZoneText1, {
            duration: 0.2,
            ease: "power1.inOut",
            alpha: 0,
            onComplete: () => {
              this.blazingZoneText1.visible = false;
            },
          });
        this.blazingZoneTextBurn1.visible = true;
        this.blazingZoneTextBurn1.gotoAndStop(0);
        this.blazingZoneTextBurn1.onComplete = () => {
          this.blazingZoneTextBurn1.visible = false;
        };
        this.blazingZoneTextBurn1.play();
      } else if (event.newFireball.coord.reel === 2) {
        this.blazingZoneText2.visible = true;
        gsap
          .timeline()
          .to(this.blazingZoneText2, {
            duration: 0.2,
            ease: "power1.inOut",
            alpha: 1,
          })
          .to(this.blazingZoneText2, {
            duration: 0.2,
            ease: "power1.inOut",
            alpha: 0,
            onComplete: () => {
              this.blazingZoneText2.visible = false;
            },
          });
        this.blazingZoneTextBurn2.visible = true;
        this.blazingZoneTextBurn2.gotoAndStop(0);
        this.blazingZoneTextBurn2.onComplete = () => {
          this.blazingZoneTextBurn2.visible = false;
        };
        this.blazingZoneTextBurn2.play();
      } else if (event.newFireball.coord.reel === 3) {
        this.blazingZoneText3.visible = true;
        gsap
          .timeline()
          .to(this.blazingZoneText3, {
            duration: 0.2,
            ease: "power1.inOut",
            alpha: 1,
          })
          .to(this.blazingZoneText3, {
            duration: 0.2,
            ease: "power1.inOut",
            alpha: 0,
            onComplete: () => {
              this.blazingZoneText3.visible = false;
            },
          });
        this.blazingZoneTextBurn3.visible = true;
        this.blazingZoneTextBurn3.gotoAndStop(0);
        this.blazingZoneTextBurn3.onComplete = () => {
          this.blazingZoneTextBurn3.visible = false;
        };
        this.blazingZoneTextBurn3.play();
      } else if (event.newFireball.coord.reel === 4) {
        this.blazingZoneText4.visible = true;
        gsap
          .timeline()
          .to(this.blazingZoneText4, {
            duration: 0.2,
            ease: "power1.inOut",
            alpha: 1,
          })
          .to(this.blazingZoneText4, {
            duration: 0.2,
            ease: "power1.inOut",
            alpha: 0,
            onComplete: () => {
              this.blazingZoneText4.visible = false;
            },
          });
        this.blazingZoneTextBurn4.visible = true;
        this.blazingZoneTextBurn4.gotoAndStop(0);
        this.blazingZoneTextBurn4.onComplete = () => {
          this.blazingZoneTextBurn4.visible = false;
        };
        this.blazingZoneTextBurn4.play();
      } else if (event.newFireball.coord.reel === 5) {
        this.blazingZoneText5.visible = true;
        gsap
          .timeline()
          .to(this.blazingZoneText5, {
            duration: 0.2,
            ease: "power1.inOut",
            alpha: 1,
          })
          .to(this.blazingZoneText5, {
            duration: 0.2,
            ease: "power1.inOut",
            alpha: 0,
            onComplete: () => {
              this.blazingZoneText5.visible = false;
            },
          });
        this.blazingZoneTextBurn5.visible = true;
        this.blazingZoneTextBurn5.gotoAndStop(0);
        this.blazingZoneTextBurn5.onComplete = () => {
          this.blazingZoneTextBurn5.visible = false;
        };
        this.blazingZoneTextBurn5.play();
      }
    }

    eventDoBBActivateAnimations(functionAfter) {
      const self = this;
      this.numberOfBBSymbols = 0;
      for (let index = 0; index < this._currentSpinPositions.length; index++) {
        const symId = this._currentSpinPositions[index][0];
        if (symId === 38) {
          this.numberOfBBSymbols++;
          const reelRow = convertIndexToReelRow(index);

          const sym = resourceManager.get(
            `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${reelRow.reel}:reel${index}`
          );
          this.doneBBActivateAnimations = true;
          gameController.reelFireballs[reelRow.reel][
            reelRow.row
          ].doBlazingBountyActivation(
            index,
            reelRow.reel,
            sym.position,
            function () {
              self.numberOfBBSymbols--;
              if (self.numberOfBBSymbols <= 0) {
                functionAfter();
              }
            }
          );
        }
      }
    }

    eventMergeSymbolsDownIntoBottomFireball(event, cb) {
      const fireBallData = event.newFireball;

      const fireballFeatureReelIndex = convertReelRowToIndex(
        fireBallData.coord.reel,
        fireBallData.coord.row
      );

      const reelIndex = convertReelRowToIndex(event.reel, 2);

      const onReelsFireballText = resourceManager.get(
        `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${
          fireBallData.coord.reel
        }:reel${fireballFeatureReelIndex}:symbol${0}:symbol:childContainer:fireballCashOverlay`
      );
      const onReelsFireball = resourceManager.get(
        `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${fireBallData.coord.reel}:reel${fireballFeatureReelIndex}`
      );
      const mergeBallValue = onReelsFireballText.modifiedValue
        ? onReelsFireballText.modifiedValue
        : parseFloat(
            onReelsFireballText.text.replace(".", "").replace("£", "")
          );
      const value = fireBallData.amount;
      //onReelsFireballText.setText(gdk.formatCurrency(value));
      let found = false;

      for (let index = 0; index < this._prizes.length; index++) {
        const prize = this._prizes[index];
        if (
          prize.reel === fireBallData.coord.reel &&
          prize.row === fireBallData.coord.row
        ) {
          prize.prizeData.type = "Cash";
          prize.prizeData.value = value;
          prize.symbolId = 19;
          found = true;
        }

        if (
          (prize.reel === fireBallData.coord.reel &&
            prize.row === fireBallData.coord.row - 1) ||
          (prize.reel === fireBallData.coord.reel &&
            prize.row === fireBallData.coord.row - 2)
        ) {
          this._prizes.splice(index, 1);
          index = -1;
        }
      }

      if (!found) {
        this._prizes.push({
          prizeData: {
            type: "Cash",
            value: value,
          },
          reel: fireBallData.coord.reel,
          row: fireBallData.coord.row,
          symbolId: this._currentSpinPositions[reelIndex][0],
        });
      }

      this.fireballsPartOfBlazingbountyMerge.push({
        symbol: onReelsFireball,
        coords: {
          reel: fireBallData.coord.reel,
          row: fireBallData.coord.row,
        },
      });

      const onReelsFireballText0 = resourceManager.get(
        `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${
          fireBallData.coord.reel
        }:reel${
          fireballFeatureReelIndex - 1
        }:symbol${0}:symbol:childContainer:fireballCashOverlay`
      );
      const onReelsFireballText1 = resourceManager.get(
        `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${
          fireBallData.coord.reel
        }:reel${
          fireballFeatureReelIndex - 2
        }:symbol${0}:symbol:childContainer:fireballCashOverlay`
      );
      const value0 = onReelsFireballText0.modifiedValue
        ? onReelsFireballText0.modifiedValue
        : parseFloat(
            onReelsFireballText0.text.replace(".", "").replace("£", "")
          );
      onReelsFireballText0.modifiedValue = undefined;
      const value1 = onReelsFireballText1.modifiedValue
        ? onReelsFireballText1.modifiedValue
        : parseFloat(
            onReelsFireballText1.text.replace(".", "").replace("£", "")
          );
      onReelsFireballText1.modifiedValue = undefined;
      //onReelsFireballText.modifiedValue = value;

      this._numberOfFireballsToMerge = 0;
      const self = this;
      const bottomSymbol = resourceManager.get(
        `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${fireBallData.coord.reel}:reel${reelIndex}`
      );

      const symbols = resourceManager.getConfiguration().symbols;
      const firstCashFireballId = symbols["Symbol_Fireball10"].ID;
      const lastCashFireballId = symbols["Symbol_Fireball5000"].ID;
      this.currentMergeValue = mergeBallValue;
      this.lockedText = false;

      if (
        this._currentSpinPositions[reelIndex - 2][0] >= firstCashFireballId &&
        this._currentSpinPositions[reelIndex - 2][0] <= lastCashFireballId
      ) {
        const symbol = resourceManager.get(
          `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${
            fireBallData.coord.reel
          }:reel${reelIndex - 2}`
        );
        //symbol.setReelSymbol(0, 17);
        this._currentSpinPositions[reelIndex - 2] = [17];
        this._numberOfFireballsToMerge++;
        //gameController.reelFireballs[event.reel][0]._fireball.visible = true;
        soundManager.play(
          `blazingBountyWooshLand${Math.floor(Math.random() * (2 - 0 + 1)) + 0}`
        );

        gameController.reelFireballs[event.reel][0].doBlazingBountyMerge(
          symbol,
          onReelsFireballText1.text,
          symbol.position,
          onReelsFireball.position,
          600,
          0.7,
          function () {
            soundManager.play("blazingBountyCountUpStart");
            gsap.to(self, {
              currentMergeValue: value,
              duration: 0.2,
              ease: "none",
              onUpdate: () => {
                if (!self.lockedText) {
                  onReelsFireballText.setText(
                    PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
                      Math.min(self.currentMergeValue, value) / 100
                    )
                  );
                  onReelsFireballText.modifiedValue = Math.min(
                    self.currentMergeValue,
                    value
                  );
                  // console.log(
                  //   "Value to Aim For: " +
                  //     value +
                  //     " Merge Value: " +
                  //     self.currentMergeValue
                  // );
                }
              },
              onComplete: () => {
                onReelsFireballText.setText(
                  PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
                    value1 / 100
                  )
                );
                onReelsFireballText.modifiedValue = value;
              },
            });
            gameController.reelFireballs[event.reel][2].reactToMerge(
              bottomSymbol.position,
              value1,
              value,
              function () {
                self._numberOfFireballsToMerge--;
                if (self._numberOfFireballsToMerge <= 0) {
                  soundManager.stop("blazingBountyCountUpEnd");
                  self.currentMergeValue = 0;
                  cb();
                }
              }
            );
          }
        );
      }

      if (
        this._currentSpinPositions[reelIndex - 1][0] >= firstCashFireballId &&
        this._currentSpinPositions[reelIndex - 1][0] <= lastCashFireballId
      ) {
        const symbol = resourceManager.get(
          `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${
            fireBallData.coord.reel
          }:reel${reelIndex - 1}`
        );
        // symbol.setReelSymbol(0, 17);
        this._currentSpinPositions[reelIndex - 1] = [17];
        this._numberOfFireballsToMerge++;

        gameController.reelFireballs[event.reel][1]._fireball.visible = true;
        soundManager.play(
          `blazingBountyWooshLand${Math.floor(Math.random() * (2 - 0 + 1)) + 0}`
        );
        gameController.reelFireballs[event.reel][1].doBlazingBountyMerge(
          symbol,
          onReelsFireballText0.text,
          symbol.position,
          onReelsFireball.position,
          200,
          0.7,
          function () {
            soundManager.play("blazingBountyCountUpStart");
            self.lockedText = true;
            const total = mergeBallValue + value0;

            gsap.to(self, {
              currentMergeValue: total,
              duration: 0.1,
              ease: "none",
              onUpdate: () => {
                const clampValue = Math.min(self.currentMergeValue, total);
                onReelsFireballText.setText(
                  PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
                    clampValue / 100
                  )
                );
                onReelsFireballText.modifiedValue = clampValue;
                // console.log(
                //   "Lower Value to Aim For: " +
                //     total +
                //     " Lower Merge Value: " +
                //     clampValue
                // );
              },
              onComplete: () => {
                onReelsFireballText.setText(
                  PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
                    total / 100
                  )
                );
                onReelsFireballText.modifiedValue = total;
                self.lockedText = false;
              },
            });
            gameController.reelFireballs[event.reel][2].reactToMerge(
              bottomSymbol.position,
              mergeBallValue,
              mergeBallValue + value0,
              function () {
                self._numberOfFireballsToMerge--;
                if (self._numberOfFireballsToMerge <= 0) {
                  soundManager.stop("blazingBountyCountUpEnd");

                  self.currentMergeValue = 0;
                  cb();
                }
              }
            );
          }
        );
      }

      if (this._currentSpinPositions[reelIndex - 1][0] !== 38) {
        this.reelsToUnlock.push(reelIndex - 1);
      }
      if (this._currentSpinPositions[reelIndex - 2][0] !== 38) {
        this.reelsToUnlock.push(reelIndex - 2);
      }

      if (this._numberOfFireballsToMerge <= 0) {
        cb();
      }
    }

    processEvent_LivesRemainingChangedEvent(event, cb) {
      //  Occurs when the number of lives remaining changes. This can be up or down.
      //     {
      //         "type": "LivesRemainingChangedEvent",
      //         "newLivesRemaining": 4
      //     },

      const self = this;

      const hasLivesReset =
        (this._livesRemaining <= 0 && event.newLivesRemaining > 0) ||
        event.newLivesRemaining === this.livesMaximum;

      this._livesRemaining = event.newLivesRemaining;

      let livesVisible = this._livesRemaining > 0 ? true : false;

      this._livesTextLabel.visible = livesVisible;
      this._lives.visible = livesVisible;

      this.setLivesTranslation(this._livesRemaining);

      const returnPos = this._lives.position;

      if (hasLivesReset) {
        gsap.fromTo(
          this._lives,
          { pixi: { scale: 0 } },
          {
            pixi: { scale: 1.2 },
            duration: 0.5,
            ease: "power1.in",
            onStart: () => {
              this._lives.text = this._livesRemaining;
            },
          }
        );

        gsap.to(this._lives.scale, {
          delay: 0.5,
          duration: 0.25,
          ease: "power1.in",
          y: 1,
          x: 1,
          yoyo: true,
        });
      }
      let time = 1000;
      if (event.newLivesRemaining === 3) {
        time = 1500;
      }
      timerManager.addTimeout(time, () => {
        cb();
      });
    }

    processEvent_MaximumLivesIncreasedEvent(event, cb) {
      // Occurs when maximum lives is increased.
      //     {
      //         "type": "MaximumLivesIncreasedEvent",
      //         "coord": {
      //             "reel": 3,
      //             "row": 2
      //         },
      //         "increment": 1,
      //         "newMaxLives": 4
      //     },

      this.livesMaximum++;
      const self = this;
      if (!this.doneRespinPlusActivateAnimations) {
        self.eventDoRespinPlusActivateAnimations(
          self.eventDoRespinPlusMove.bind(self, event, cb)
        );
      } else {
        self.eventDoRespinPlusMove(event, cb);
      }
    }

    eventDoRespinPlusActivateAnimations(functionAfter) {
      const self = this;
      this.numberOfRespinSymbols = 0;
      for (let index = 0; index < this._currentSpinPositions.length; index++) {
        const symId = this._currentSpinPositions[index][0];
        if (symId === 37) {
          this.numberOfRespinSymbols++;
          const reelRow = convertIndexToReelRow(index);

          const sym = resourceManager.get(
            `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${reelRow.reel}:reel${index}`
          );
          this.doneRespinPlusActivateAnimations = true;
          gameController.reelFireballs[reelRow.reel][
            reelRow.row
          ].doRespinPlusActivation(sym.position, function () {
            self.numberOfRespinSymbols--;
            if (self.numberOfRespinSymbols <= 0) {
              functionAfter();
            }
          });
        }
      }
    }

    eventDoRespinPlusMove(event, cb) {
      const self = this;
      const fireballFeatureReelIndex = convertReelRowToIndex(
        event.coord.reel,
        event.coord.row
      );

      const symbol = resourceManager.get(
        `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${event.coord.reel}:reel${fireballFeatureReelIndex}`
      );

      gameController.reelFireballs[event.coord.reel][
        event.coord.row
      ].doRespinPlusMove(symbol.position, 100, function () {
        self.eventIncreaseLives(event, cb);
      });
    }

    eventIncreaseLives(event, cb) {
      // Occurs when
      const self = this;
      this._livesRemaining = event.newMaxLives;
      soundManager.play("lifeInc");
      let livesVisible = this._livesRemaining > 0 ? true : false;

      this._livesTextLabel.visible = livesVisible;
      this._lives.visible = livesVisible;

      this.setLivesTranslation(this._livesRemaining);

      const fireballFeatureReelIndex = convertReelRowToIndex(
        event.coord.reel,
        event.coord.row
      );

      for (let index = 0; index < this._prizes.length; index++) {
        const prize = this._prizes[index];
        if (prize.reel === event.coord.reel && prize.row === event.coord.row) {
          this._prizes.splice(index, 1);
          break;
        }
      }

      const lockedReelsIndex = this._lockedReels.indexOf(
        fireballFeatureReelIndex
      );
      const newLockedReelsIndex = this._newLockedReels.indexOf(
        fireballFeatureReelIndex
      );
      if (lockedReelsIndex !== -1) {
        this._lockedReels.splice(lockedReelsIndex, 1);
      }
      if (newLockedReelsIndex !== -1) {
        this._newLockedReels.splice(newLockedReelsIndex, 1);
      }

      this._lives.visible = true;

      const returnPos = self._lives.position;
      const lives = self._lives;

      gsap
        .timeline()
        .to(lives.scale, {
          duration: 0.5,
          ease: "power1.in",
          y: 1.2,
          x: 1.2,
        })
        .to(lives.scale, {
          duration: 0.25,
          ease: "power1.in",
          y: 1,
          x: 1,
          yoyo: true,
          onComplete: () => {
            timerManager.addTimeout(250, function () {
              self._lives.text = self._livesRemaining;

              cb();
            });
          },
        });
    }

    processEvent_MegaPotAwardedEvent(event, cb) {
      // Occurs when the mega pot is awarded. Note awardedValue is in cash while
      //   'newMegaPotValue' is in the stake independent format.
      //     {
      //         "type": "MegaPotAwardedEvent",
      //         "awardedValue": 5320,
      //         "newMagaPotValue": 5000
      //     }

      this.awardJackpot(event, cb);
    }

    awardJackpot(event, cb) {
      const self = this;

      this._megaPotWon = true;
      this._megaPotValue = event.awardedValue;

      const stakeController = resourceManager.getController("stakeController");
      const stake = stakeController.getCurrentStake("default");
      const megaPot = resourceManager.get("potContainer:potMega:value");
      self.megaPotAwardValue.setText(gdk.formatCurrency(event.awardedValue));
      self.megaPotAward.visible = true;
      const oldPos = 0;
      self.megaPotAward.position.y = oldPos;
      self.dimReels.alpha = 0;
      self.dimReels.visible = true;
      gsap.to(self.dimReels, {
        duration: 0.2,
        ease: "power1.inOut",
        alpha: 1,
      });
      self.megaPotAward.scale = { x: 0, y: 0 };
      gsap.to(self.megaPotAward.scale, {
        duration: 0.5,
        ease: "bounce",
        x: 1,
        y: 1,
      });

      gsap
        .timeline()
        .to(self.megaPotAward.position, {
          duration: 0.8,
          ease: "linear",
          y: oldPos + 4,
        })
        .to(self.megaPotAward.position, {
          duration: 0.8,
          ease: "linear",
          y: oldPos - 8,
          onComplete: () => {},
        })
        .to(self.megaPotAward.position, {
          duration: 0.8,
          ease: "linear",
          y: oldPos,
        })
        .to(self.megaPotAward.position, {
          duration: 0.8,
          ease: "linear",
          y: oldPos + 4,
        })
        .to(self.megaPotAward.scale, {
          duration: 0.2,
          ease: "linear",
          y: 1.1,
          x: 1.1,
          onStart: () => {
            gsap.to(self.megaPotAward.position, {
              duration: 0.6,
              ease: "linear",
              y: oldPos - 100,
            });
          },
          onComplete: () => {
            gsap.to(self.megaPotAward.position, {
              duration: 0.6,
              ease: "linear",
              y: oldPos + 1000,
            });
            gsap.to(self.megaPotAward.scale, {
              duration: 0.4,
              ease: "linear",
              y: 0,
              x: 0,
            });
          },
        });

      // pot.awardEmitter.visible = true;
      // pot.awardEmitter.particleEmitter.emit = true;

      self.rays.visible = true;

      self.rays.rotation = 0;

      gsap.to(self.rays, {
        duration: 3.5,
        rotation: Math.PI * 2,
        ease: "linear",
        onComplete: () => {
          self.rays.visible = false;
        },
      });

      timerManager.addTimeout(4500, function () {
        gsap.to(self.dimReels, {
          duration: 0.2,
          ease: "power1.inOut",
          alpha: 0,
          onComplete: () => {
            self.dimReels.visible = false;
          },
        });
        self.rays.visible = false;

        self.megaPotAward.scale = { x: 1, y: 1 };
        self.megaPotAward.position.y = oldPos.y;
        self.megaPotAward.visible = false;
        self._winnings += event.awardedValue;

        self._megaPotResetValue = gdk.formatCurrency(
          event.newMagaPotValue *
            (stake / gameData.gameConfig.winLinesForCashConversion)
        );

        timerManager.addTimeout(300, function () {
          cb();
        });
      });
    }

    onfireballLinkStartEvent(task) {
      // set off the intro
      gameData.musicManager.setIdleMusic();
      gameData.musicManager.increaseLevel("base");
      this._active = true;
      this._fireballLinkStartTask = task;
      this._fireballLinkStartTask.join();
      this.infoPanel.visible = true;
      this.blazingHotZones = [false, false, false, false, false, false];
      this._lockedReels = [];
      this._newLockedReels = [];
      this.reelsToUnlock = [];
      const self = this;

      for (let i = 0; i < this._slotMachine._reelVisuals.length; i++) {
        this._slotMachine._reelVisuals[i].clearSuspendUpdates();
      }
      for (let i = 0; i < gameController.slotMachine._reelVisuals.length; i++) {
        gameController.slotMachine._reelVisuals[i].suspendUpdates();
      }

      gameController.volcano.setSkin("Night");
      this._logo = resourceManager.get("baseGameLogo");
      this._logo.visible = false;
      let goldenBetButton = resourceManager.get("goldenBetToggleButton");
      goldenBetButton.glow.visible = false;

      let animationName = "x" + gameController.currentBlazingMultiplier;
      animationName = animationName.replace(".", "_");
      gameController.gatewayThermometer.play(animationName, true, 0, undefined);

      // gameData.musicManager.fadeOutAllMusic();
      // gameData.musicManager.fadeInFireballMusic();
      this._shaker.doShake(1500);
      // Set up fireballs on BB reels
      task.data.startingFireballs.forEach(function (fireball) {
        const id = fireball.reel * gameData.numRows + fireball.row;

        gameData.reels[fireball.reel].setReelSymbol(
          fireball.row,
          fireball.symbolId
        );
        self._currentSpinPositions[id] = [fireball.symbolId];
        self._newLockedReels.push(id);

        self._prizes.push({
          prizeData: fireball.prizeData,
          reel: fireball.reel,
          row: fireball.row,
          symbolId: fireball.symbolId,
        });
      });

      for (let reel = 0; reel < gameData.numReels; ++reel) {
        for (let row = 0; row < gameData.numRows; ++row) {
          const id = reel * gameData.numRows + row;
          const rv = resourceManager.get(
            "slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup" +
              reel +
              ":reel" +
              id
          );
          const prizeContainer = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id
          );
          prizeContainer.position = rv.position;
        }
      }

      this.blazingZone0 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone0"
      );
      this.blazingZone1 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone1"
      );
      this.blazingZone2 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone2"
      );
      this.blazingZone3 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone3"
      );
      this.blazingZone4 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone4"
      );
      this.blazingZone5 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone5"
      );

      this.blazingZoneGrow0 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone0:grow"
      );
      this.blazingZoneGrow1 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone1:grow"
      );
      this.blazingZoneGrow2 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone2:grow"
      );
      this.blazingZoneGrow3 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone3:grow"
      );
      this.blazingZoneGrow4 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone4:grow"
      );
      this.blazingZoneGrow5 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone5:grow"
      );
      this.blazingZoneLoop0 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone0:loop"
      );
      this.blazingZoneLoop1 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone1:loop"
      );
      this.blazingZoneLoop2 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone2:loop"
      );
      this.blazingZoneLoop3 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone3:loop"
      );
      this.blazingZoneLoop4 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone4:loop"
      );
      this.blazingZoneLoop5 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone5:loop"
      );
      this.blazingZoneText0 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone0:Blazing"
      );
      this.blazingZoneTextBurn0 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone0:BlazingTextBurn"
      );
      this.blazingZoneText1 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone1:Blazing"
      );
      this.blazingZoneTextBurn1 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone1:BlazingTextBurn"
      );
      this.blazingZoneText2 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone2:Blazing"
      );
      this.blazingZoneTextBurn2 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone2:BlazingTextBurn"
      );
      this.blazingZoneText3 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone3:Blazing"
      );
      this.blazingZoneTextBurn3 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone3:BlazingTextBurn"
      );
      this.blazingZoneText4 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone4:Blazing"
      );
      this.blazingZoneTextBurn4 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone4:BlazingTextBurn"
      );
      this.blazingZoneText5 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone5:Blazing"
      );
      this.blazingZoneTextBurn5 = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:blazingZone5:BlazingTextBurn"
      );
      this.blazingZoneText0.blendMode = PIXI.BLEND_MODES.ADD;
      this.blazingZoneText1.blendMode = PIXI.BLEND_MODES.ADD;
      this.blazingZoneText2.blendMode = PIXI.BLEND_MODES.ADD;
      this.blazingZoneText3.blendMode = PIXI.BLEND_MODES.ADD;
      this.blazingZoneText4.blendMode = PIXI.BLEND_MODES.ADD;
      this.blazingZoneText5.blendMode = PIXI.BLEND_MODES.ADD;
      gameController.stormLinkSkip = true;

      this._fireballLinkStartData = task.data;
      this.isWincapped = task.data.winCapped;
      if (this.isWincapped) {
        this._maxWin = task.data.winCappedAmount;
      }

      this._linkBG.visible = true;
      this._linkBGPortrait.visible = true;

      resourceManager.get("slotContainer:jackpotReelsLogo").visible = false;
      resourceManager.get("slotContainer:triggeredByVolcano").visible = false;

      gameController.isInFeature = true;
      gameController.wildLandAnimator.skip();
      const symbols = resourceManager.getConfiguration().symbols;
      this._slotMachine.highlightSymbolIds([
        symbols["Symbol_Fireball10"].ID,
        symbols["Symbol_Fireball20"].ID,
        symbols["Symbol_Fireball30"].ID,
        symbols["Symbol_Fireball40"].ID,
        symbols["Symbol_Fireball50"].ID,
        symbols["Symbol_Fireball100"].ID,
        symbols["Symbol_Fireball150"].ID,
        symbols["Symbol_Fireball200"].ID,
        symbols["Symbol_Fireball250"].ID,
        symbols["Symbol_Fireball500"].ID,
        symbols["Symbol_Fireball1000"].ID,
        symbols["Symbol_Fireball2000"].ID,
        symbols["Symbol_Fireball5000"].ID,
        symbols["Symbol_FireballMini"].ID,
        symbols["Symbol_FireballMinor"].ID,
        symbols["Symbol_FireballMajor"].ID,
        symbols["Symbol_FireballMega"].ID,
        symbols["Symbol_FireballExtraHot"].ID,
        symbols["Symbol_FireballRespinPlus"].ID,
        symbols["Symbol_FireballBlazingBounty"].ID,
        symbols["Symbol_FireballX2"].ID,
      ]);

      this.events = task.data.onEntryEvents;
      this.eventIndex = 0;

      this.afterEventsProcessedCallback =
        this.fireballLinkStartCallback.bind(this);
      soundManager.play("bonusWon");
      gameData.musicManager.fadeOutAllMusic();

      timerManager.addTimeout(1500, function () {
        gameData.musicManager.setIdleMusic();
        gameData.musicManager.increaseLevel("base");
        self._fblLogo = resourceManager.get("slotContainer:stormLinkLogo");
        self._fblLogo.visible = true;
        gameController.baseReelFrame.visible = false;
        self._reelFrame.visible = true;
        self._fireBallIntro.showContinue(
          self.showFireballLinkStartIntro.bind(self)
        );
      });
    }

    showFireballLinkStartIntro() {
      const self = this;
      this._currentSpinPositions.forEach(function (position, id) {
        const reel = Math.floor(id / gameData.numRows);
        const row = id % gameData.numRows;
        const onBaseGameReelsFireBallText = resourceManager.get(
          `slotContainer:reelContainer:reel${reel}:symbol${row}:symbol_standard:childContainer:fireballCashOverlay`
        );
        const onReelsFireballText = resourceManager.get(
          `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${reel}:reel${id}:symbol${0}:symbol:childContainer:fireballCashOverlay`
        );
        onReelsFireballText.modifiedValue =
          onBaseGameReelsFireBallText.modifiedValue;
      });
      this._fireBallIntro.showIntro(self.processEvents.bind(self));
    }

    fireballLinkStartCallback() {
      messageBus.post("spinner:stormLink");

      this._fireballLinkStartTask.leave();
      gameController.wildLandAnimator.visible = false;
      // gameData.musicManager.fadeOutAllMusic();
      // gameData.musicManager.fadeInFireballMusic();
      gameController.volcano.setSkin("Night");
      soundManager.play("multiplierUnlock");
      gameController.padlock.play("Padlock_Pop_Unlock", false, 0, undefined);

      resourceManager.getController("inputOverlord").setState("freespins");

      gameController.slotMachine.clearDimSymbolIds();

      this._livesTextLabel.visible = true;

      this._livesRemaining = this._fireballLinkStartData.livesRemaining;
      this._lives.text = this._livesRemaining;
      this._lives.visible = true;
      this.livesMaximum = this._livesRemaining;
      this.setLivesTranslation(this._livesRemaining);

      this._fireballsCollected =
        this._fireballLinkStartData.startingFireballs.length;

      //TODO: HB Keeping this incase it comes back
      //this._collectedText.setText(this._fireballsCollected);

      this._winningsText.setText("0.00");

      this._lockedReels = [];
      this._newLockedReels = [];

      this._prizes = [];

      const symbolInfo = resourceManager.getConfiguration().symbols;
      //transfer base game symbols over to these reels
      for (let reel = 0; reel < gameData.numReels; reel++) {
        for (let row = 0; row < gameData.numRows; row++) {
          let symbolId = this._currentBaseGameSymbols[reel][row];
          if (
            symbolId === symbolInfo["Symbol_SWild_x2"].ID ||
            symbolId === symbolInfo["Symbol_SWild_x3"].ID
          ) {
            symbolId = symbolInfo["Symbol_SWild"].ID;
          }
          this._reels[reel][row].setReelSymbol(0, symbolId);
          const symbolPos = gameController.slotMachine.getSymbolPosition(
            reel,
            row
          );
          this._reels[reel][row].position = symbolPos;
        }
      }

      const self = this;
      // for (let index = 0; index < 18; index++) {
      //   this._currentSpinPositions[index] = [17];
      //   const reelRow = convertIndexToReelRow(index);

      //   gameData.reels[reelRow.reel].setReelSymbol(reelRow.row, 17);
      // }

      this._fireballLinkStartData.startingFireballs.forEach(function (
        fireball
      ) {
        self._reels[fireball.reel][fireball.row].setReelSymbol(
          0,
          fireball.symbolId
        );
        const id = fireball.reel * gameData.numRows + fireball.row;
        const lockedReelsIndex = self._lockedReels.indexOf(id);
        if (lockedReelsIndex === -1) {
          self._lockedReels.push(id);
        }

        self._prizes.push({
          prizeData: fireball.prizeData,
          reel: fireball.reel,
          row: fireball.row,
          symbolId: fireball.symbolId,
        });
      });

      for (let reel = 0; reel < gameData.numReels; ++reel) {
        for (let row = 0; row < gameData.numRows; ++row) {
          const id = reel * gameData.numRows + row;
          const rv = resourceManager.get(
            "slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup" +
              reel +
              ":reel" +
              id
          );
          const prizeContainer = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id
          );
          prizeContainer.position = rv.position;
        }
      }

      resourceManager.get("slotContainer:reelContainer").visible = false;
      this.visible = true;

      // slightly delay the first spin to give player the chance of seeing
      // initial number of respins otherwise it will have decremented straight away
      timerManager.addTimer(1000, undefined, function () {
        self.getNextSpinOutcome();
      });
    }

    processMultiSymbolWilds(reel, row, newSymbolId) {
      const symbolsInfo = resourceManager.getConfiguration().symbols;
      //if this fireball is going into a slot currently occupied by part of a x2 or 2x wild, we need to change the rest of that 2x or x3 wild
      const baseGameSymbolid = this._currentBaseGameSymbols[reel][row];
      if (baseGameSymbolid === symbolsInfo["Symbol_SWild_x2"].ID) {
        if (row === 0) {
          //if the x2 wild starts on the top row, we need to turn the row below into a x1 wild
          gameData.reels[reel].setReelSymbol(
            row + 1,
            symbolsInfo["Symbol_SWild"].ID
          );
          this._currentBaseGameSymbols[reel][row + 1] =
            symbolsInfo["Symbol_SWild"].ID;
        } else if (row === 1) {
          //find out if the symbol above or below is the rest of the 2x wild and turn that one into a x1 wild
          if (
            this._currentBaseGameSymbols[reel][row - 1] ===
            symbolsInfo["Symbol_SWild_x2"].ID
          ) {
            gameData.reels[reel].setReelSymbol(
              row - 1,
              symbolsInfo["Symbol_SWild"].ID
            );
            this._currentBaseGameSymbols[reel][row - 1] =
              symbolsInfo["Symbol_SWild"].ID;
          } else {
            gameData.reels[reel].setReelSymbol(
              row + 1,
              symbolsInfo["Symbol_SWild"].ID
            );
            this._currentBaseGameSymbols[reel][row + 1] =
              symbolsInfo["Symbol_SWild"].ID;
          }
        } else {
          //if the x2 wild starts on the top row, we need to turn the row above into a x1 wild
          gameData.reels[reel].setReelSymbol(
            row - 1,
            symbolsInfo["Symbol_SWild"].ID
          );
          this._currentBaseGameSymbols[reel][row - 1] =
            symbolsInfo["Symbol_SWild"].ID;
        }
      } else if (baseGameSymbolid === symbolsInfo["Symbol_SWild_x3"].ID) {
        if (row === 0) {
          gameData.reels[reel].setReelSymbol(
            row + 1,
            symbolsInfo["Symbol_SWild_x2"].ID
          );
          gameData.reels[reel].setReelSymbol(
            row + 2,
            symbolsInfo["Symbol_SWild_x2"].ID
          );
          this._currentBaseGameSymbols[reel][row + 1] =
            symbolsInfo["Symbol_SWild_x2"].ID;
          this._currentBaseGameSymbols[reel][row + 2] =
            symbolsInfo["Symbol_SWild_x2"].ID;
        } else if (row === 1) {
          gameData.reels[reel].setReelSymbol(
            row - 1,
            symbolsInfo["Symbol_SWild"].ID
          );
          gameData.reels[reel].setReelSymbol(
            row + 1,
            symbolsInfo["Symbol_SWild"].ID
          );
          this._currentBaseGameSymbols[reel][row - 1] =
            symbolsInfo["Symbol_SWild"].ID;
          this._currentBaseGameSymbols[reel][row + 1] =
            symbolsInfo["Symbol_SWild"].ID;
        } else {
          gameData.reels[reel].setReelSymbol(
            row - 1,
            symbolsInfo["Symbol_SWild_x2"].ID
          );
          gameData.reels[reel].setReelSymbol(
            row - 2,
            symbolsInfo["Symbol_SWild_x2"].ID
          );
          this._currentBaseGameSymbols[reel][row - 1] =
            symbolsInfo["Symbol_SWild_x2"].ID;
          this._currentBaseGameSymbols[reel][row - 2] =
            symbolsInfo["Symbol_SWild_x2"].ID;
        }
      }
      this._currentBaseGameSymbols[reel][row] = newSymbolId;
    }

    doSlamStop() {
      if (!this._active) return;

      let reelsToSlam = [];
      soundManager.play("reelStop0");
      for (var i = 0; i < 18; i++) {
        reelsToSlam.push(i);
      }
      this._slotMachine.slamReels(reelsToSlam);

      this.slamStopped = true;
      if (this?._dataEvent?.data?.newFireballs.length > 0) {
        soundManager.play(`fireBallLand0`);
      }
      if (this._reelsTimer !== undefined) {
        this._reelsTimer.remainingTime = 0;
      }
      soundManager.stop("reelSpin");
    }

    onfireballLinkDataEvent(task) {
      const self = this;
      this._dataEvent = task;
      this._dataEvent.join();
      self.spinning = true;

      this.events = task.data.events;
      this.afterEventsProcessedCallback = undefined;
      this.afterEventsProcessedCallback =
        self.onfireballLinkDataEventCallback.bind(self);

      for (let index = 0; index < this.reelsToUnlock.length; index++) {
        const reelIndex = this.reelsToUnlock[index];
        let lockedReelIndex = this._lockedReels.indexOf(reelIndex);
        let newLockedReelIndex = this._newLockedReels.indexOf(reelIndex);
        while (lockedReelIndex !== -1) {
          this._lockedReels.splice(lockedReelIndex, 1);
          lockedReelIndex = this._lockedReels.indexOf(reelIndex);
        }
        while (newLockedReelIndex !== -1) {
          this._newLockedReels.splice(newLockedReelIndex, 1);
          newLockedReelIndex = this._newLockedReels.indexOf(reelIndex);
        }
      }

      this._lockedReels.push(...this._newLockedReels);
      this._newLockedReels = [];
      this.reelsToUnlock = [];
      this._slotMachine.holdReels(this._lockedReels);
      soundManager.play("reelSpin");
      this._reelstopIdx = 0;
      this._slotMachine.infiniteSpin();

      const oldSpinPositions = this._currentSpinPositions;

      this._currentSpinPositions = [];

      let aboveBelow = [];

      for (let reel = 0; reel < this._reels.length; reel++) {
        const reelList = this._reels[reel];
        for (let row = 0; row < reelList.length; row++) {
          const reelObj = reelList[row];

          aboveBelow.push([]);
          self._currentSpinPositions.push([0]);
        }
      }

      for (let reel = 0; reel < gameData.reels.length; reel++) {
        gameData.reels[reel]._lockedCashValues = true;
        for (let row = 0; row < 3; row++) {
          const index = convertReelRowToIndex(reel, row);
          const isLocked = self._lockedReels.indexOf(index);
          if (isLocked !== -1) {
            self._currentSpinPositions[index] = oldSpinPositions[index];
          }
        }
      }

      task.data.newFireballs.forEach(function (fireball) {
        const id = fireball.reel * gameData.numRows + fireball.row;

        self.processMultiSymbolWilds(
          fireball.reel,
          fireball.row,
          fireball.symbolId
        );

        gameData.reels[fireball.reel].setReelSymbol(
          fireball.row,
          fireball.symbolId
        );
        self._currentSpinPositions[id] = [fireball.symbolId];
        self._newLockedReels.push(id);

        self._prizes.push({
          prizeData: fireball.prizeData,
          reel: fireball.reel,
          row: fireball.row,
          symbolId: fireball.symbolId,
        });
      });

      // add fireballs collected
      this._fireballsCollected += task.data.newFireballs.length;

      task.data.blanks.forEach(function (blank) {
        const id = blank.coord.reel * gameData.numRows + blank.coord.row;
        self._currentSpinPositions[id] = [blank.symbol];
      });

      self._slotMachine.stopReels(
        self._currentSpinPositions,
        aboveBelow,
        aboveBelow,
        function () {
          if (self._livesRemaining === 3) {
            soundManager.play("lifeReset");
          }
          self.eventIndex = 0;
          self.spinning = false;
          timerManager.addTimeout(200, () => {
            self._fireballLandAnimator.skip();
            self.processEvents();
          });
          //self.processEvents();
        }
      );
    }

    onfireballLinkDataEventCallback() {
      if (!this.spinning) {
        this._dataEvent.leave();
      } else {
        console.log("fireball data event dead triggered again!");
      }
    }

    onfireballLinkDataEventDead(task) {
      messageBus.post("spinner:stormLinkEnd");
      this.spinning = true;
      soundManager.stop("reelSpin");
      this.getNextSpinOutcome();
    }

    doLandAnimations(reelIndex) {
      let symbolsToAnimate = [];

      //const index = convertReelRowToIndex(reelIndex, rowIndex);
      const symbol = this._currentSpinPositions[reelIndex];
      symbolsToAnimate.push({
        cell: { reel: reelIndex, row: 0 },
        symbolId: symbol[0],
      });

      if (symbol[0] >= 36 && symbol[0] <= 38 && !this.slamStopped) {
        this._fireballLandAnimator.animateSymbols(
          symbolsToAnimate,
          this._slotMachine,
          true,
          false,
          function () {
            // self.symbolLandAnimationsPlaying--;
            // if (self.symbolLandAnimationsPlaying <= 0 && !self.spinning) {
            //   self.processEvents();
            // }
          }
        );
      }
    }

    doFullFireballCelebration(callback) {
      soundManager.play("freeSpinsBonusWon");

      for (let index = 0; index < 6; index++) {
        const text = this[`blazingZoneText${index}`];
        text.visible = true;
        gsap
          .timeline()
          .to(text, {
            duration: 0.25,
            ease: "power1.inOut",
            alpha: 1,
          })
          .to(text, {
            duration: 0.25,
            ease: "power1.inOut",
            alpha: 0,
          })
          .to(text, {
            duration: 0.25,
            ease: "power1.inOut",
            alpha: 1,
          })
          .to(text, {
            duration: 0.25,
            ease: "power1.inOut",
            alpha: 0,
          })
          .to(text, {
            duration: 0.25,
            ease: "power1.inOut",
            alpha: 1,
          })
          .to(text, {
            duration: 0.25,
            ease: "power1.inOut",
            alpha: 0,
          })
          .to(text, {
            duration: 0.25,
            ease: "power1.inOut",
            alpha: 1,
          })
          .to(text, {
            duration: 0.25,
            ease: "power1.inOut",
            alpha: 0,
            onComplete: () => {
              text.visible = false;
            },
          });
      }

      const megaPot = resourceManager.get("potContainer:potMega");
      gsap
        .timeline()
        .to(megaPot.scale, {
          x: 1.2,
          y: 1.2,
          duration: 0.25,
        })
        .to(megaPot.scale, {
          x: 1,
          y: 1,
          duration: 0.25,
        })
        .to(megaPot.scale, {
          x: 1.2,
          y: 1.2,
          duration: 0.25,
        })
        .to(megaPot.scale, {
          x: 1,
          y: 1,
          duration: 0.25,
        })
        .to(megaPot.scale, {
          x: 1.2,
          y: 1.2,
          duration: 0.25,
        })
        .to(megaPot.scale, {
          x: 1,
          y: 1,
          duration: 0.25,
        })
        .to(megaPot.scale, {
          x: 1.2,
          y: 1.2,
          duration: 0.25,
        })
        .to(megaPot.scale, {
          x: 1,
          y: 1,
          duration: 0.25,
          onComplete: () => {
            resourceManager
              .get("potContainer:potMega:value")
              .setText(this._megaPotResetValue);
          },
        });

      let symbolsToAnimate = [];
      this._prizes.forEach(function (prize) {
        const reel = prize.reel * gameData.numRows + prize.row;
        symbolsToAnimate.push({
          cell: { reel, row: 0 },
          symbolId: prize.symbolId,
        });
      });

      const self = this;
      timerManager.addTimer(
        1000,
        function () {},
        function () {
          const x = layoutController.getCurrentPosition(
            self._megaValue.Props.FQN
          ).x;
          const y = layoutController.getCurrentPosition(
            self._megaValue.Props.FQN
          ).y;
          self._megaValue.position.set(x, y);
          self._megaValue.visible = false;
          self.countUpPrize(self._megaPotValue, function () {}, 1000);
        }
      );
      this._fireballLandAnimator.animateSymbols(
        symbolsToAnimate,
        this._slotMachine,
        true,
        true,
        function () {
          self._fireballLandAnimator.animateSymbols(
            symbolsToAnimate,
            self._slotMachine,
            true,
            true,
            function () {
              self._fireballLandAnimator.animateSymbols(
                symbolsToAnimate,
                self._slotMachine,
                true,
                true,
                function () {
                  callback();
                }
              );
            }
          );
        }
      );
    }

    skip() {
      this._skipped = true;
    }

    skipped(callback) {
      let total = this._megaPotWon ? this._megaPotValue : 0;
      let multiplier = 1;

      for (let i = 0; i < this._prizes.length; i++) {
        let prize = this._prizes[i];
        let prizeType = prize.prizeData.type;

        if (
          prizeType === "Cash" ||
          prizeType === "WildCash" ||
          prizeType === "Pot" ||
          prizeType === "WildPot"
        ) {
          total += prize.prizeData.value;
        } else if (
          prizeType === "Multiplier" ||
          prizeType === "WildMultiplier"
        ) {
          multiplier *= prize.prizeData.value;
        }
      }

      this.countUpToNumber(total * multiplier, callback, 1000);
    }

    getCurrentMaxWin() {
      if (this.isWincapped) {
        return this._maxWin;
      } else {
        return this._endTaskWinnings;
      }
    }

    getCurrentEventType() {
      return this.events?.[this.eventIndex - 1]?.type;
    }

    getNumberOfMerges() {
      let numberofMerges = 0;
      for (let i = this.eventIndex; i < this.events.length; i++) {
        if (this.events[i].type === "BlazingZoneMergeEvent") {
          numberofMerges++;
        } else {
          return numberofMerges;
        }
      }
    }

    sortPrizes() {
      // we want to fire off prizes in order of left to right reels and top to bottom on each reel
      // this also handles multipliers - and they end up being stored in the multiplier array
      // in the same order left to right/top to bottom
      let tempPrizes = [];
      soundManager.play("fireballEndCountLoop");

      for (let reel = 0; reel < gameData.numReels; reel++) {
        for (let row = 0; row < gameData.numRows; row++) {
          // search for each reel/row and if found add to tempPrizes
          for (let i = 0; i < this._prizes.length; i++) {
            if (this._prizes[i].reel === reel && this._prizes[i].row === row) {
              tempPrizes.push(this._prizes[i]);
              break;
            }
          }
        }
      }

      this._prizes = JSON.parse(JSON.stringify(tempPrizes));

      //remove prizes past the max win
      let runningTotal = 0;
      if (this._fireballsCollected >= gameData.numReels * gameData.numRows) {
        runningTotal += this._megaPotValue;
      }
      let i = 0;
      for (; i < this._prizes.length; i++) {
        runningTotal += this._prizes[i].prizeData.value;
        if (runningTotal >= this.getCurrentMaxWin()) {
          break;
        }
      }
      this._prizes.splice(i + 1, this._prizes.length - (i - 1));
    }

    /**
     * Returns a random integer between min (inclusive) and max (inclusive).
     * The value is no lower than min (or the next integer greater than min
     * if min isn't an integer) and no greater than max (or the next integer
     * lower than max if max isn't an integer).
     */
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    animateCoinWoosh(startPos, endPos, duration) {
      const group = this._coinGroup1;

      for (let i = 0; i < group.length; i++) {
        const coin = group[i];
        const xx = this.getRandomInt(-20, 20);
        const yy = this.getRandomInt(-25, -15);
        const rotation = this.getRandomInt(0, 10);

        coin.visible = true;
        coin.scale.set(0.15, 0.15);
        coin.rotation = rotation;
        coin.position.set(startPos.x + xx, startPos.y + yy);
        coin.alpha = 0;

        gsap
          .timeline()
          .to(
            coin,
            {
              onStart: () => {
                coin.alpha = 1;
              },
              duration,
              delay: i / 50,
              pixi: { scaleX: 0, scaleY: 0 },
              ease: "power3.in",
            },
            "<"
          )
          .to(
            coin,
            {
              duration,
              delay: i / 50,
              x: endPos.x,
              y: endPos.y,
              ease: "power1.out",
              onComplete: () => {
                coin.visible = false;
              },
            },
            "<"
          );
      }
    }

    collectPrize(objectToMove, reel, row, callback) {
      soundManager.play(
        `fireballWhoosh${Math.floor(Math.random() * (2 - 0 + 1) + 0)}`
      );
      const symbolInfo = resourceManager.getConfiguration().symbols;
      const symbolId = this._currentBaseGameSymbols[reel][row];

      const posX = objectToMove.x;
      const posY = objectToMove.y;

      const endPos = layoutController.getCurrentPosition(
        this._winningsPanel.Props.FQN
      );

      const speed = 3;
      const distanceX = Math.max(1, posX - endPos.x);
      const distanceY = Math.max(1, posY - endPos.y);
      const distance = distanceX + distanceY;
      const time = (1 + distance / 1000) / speed;

      if (symbolId >= 18) {
        soundManager.play(
          `blazingBountyWooshLand${Math.floor(Math.random() * (2 - 0 + 1)) + 0}`
        );
      }

      objectToMove.visible = true;

      this.animateCoinWoosh({ x: posX, y: posY }, endPos, time);

      gsap
        .timeline()
        .to(objectToMove, {
          duration: 0.2,
          pixi: { scaleX: 1.3, scaleY: 1.3 },
          ease: "power1.out",
        })
        .to(objectToMove, {
          duration: 0.2,
          pixi: { scaleX: 1, scaleY: 1 },
          ease: "power1.in",
          onComplete: () => {
            objectToMove.visible = false;
            objectToMove.alpha = 1;
            callback();
          },
        });
    }

    toggleOverlay(show, reel, row) {
      this._stormLinkReels[reel][row].alpha = show ? 1 : 0;
      this._freeSpinsReels[reel][row].alpha = show ? 1 : 0;
    }

    setWinnings(newWinnings) {
      this._winnings = newWinnings;
    }

    countUpToNumber(total, callback, duration = 350) {
      const self = this;
      const start = this._winnings;
      const end = Math.min(total, this.getCurrentMaxWin());
      timerManager.addTimer(
        duration,
        function (progress) {
          const val = Math.floor(start + (end - start) * progress);
          self._winningsText.setText(
            PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
              val / 100
            )
          );

          let newScale = 1 + 0.25 * Math.abs(Math.sin(Math.PI * progress));
          self._winningsTextContainer.scale.set(newScale, newScale);
        },
        function () {
          self._winnings = end;
          self._winningsText.setText(
            PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
              self._winnings / 100
            )
          );
          self._winningsTextContainer.scale.set(1, 1);
          callback();
        }
      );
    }

    countUpPrize(newValue, callback, duration = 350) {
      const self = this;
      const start = this._winnings;
      const end = Math.min(start + newValue, this.getCurrentMaxWin());
      soundManager.play("countUpLoop");

      timerManager.addTimer(
        duration,
        function (progress) {
          const val = Math.floor(start + (end - start) * progress);
          self._winningsText.setText(
            PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
              val / 100
            )
          );

          let newScale = 1 + 0.25 * Math.abs(Math.sin(Math.PI * progress));
          self._winningsTextContainer.scale.set(newScale, newScale);
        },
        function () {
          self._winnings = end;
          self._winningsText.setText(
            PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
              self._winnings / 100
            )
          );
          self._winningsTextContainer.scale.set(1, 1);
          soundManager.play("countUpLoopEnd");
          soundManager.stop("countUpLoop");
          callback();
        }
      );
    }

    startShowPrizesFromExt(winnings) {
      this._winnings = winnings;
      this._winningsText.setText(
        PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
          winnings / 100
        )
      );
    }

    showWinningsPanel(show, callback) {
      if (
        (show && !this._winningsPanel.visible) ||
        (!show && this._winningsPanel.visible)
      ) {
        if (show) {
          this._winningsPanel.visible = true;
          this._winningsPanel.alpha = 0;
          this._fblLogo.visible = true;
          timerManager.addTimer(
            250,
            function (progress) {
              self._fblLogo.alpha = 1 - progress;
            },
            function () {
              self._fblLogo.alpha = 1;
              self._fblLogo.visible = false;
            }
          );
        }
        const self = this;
        timerManager.addTimer(
          500,
          function (progress) {
            if (show) {
              self._winningsPanel.alpha = progress;
            } else {
              self._winningsPanel.alpha = 1 - progress;
            }
          },
          function () {
            self._winningsPanel.alpha = 1;
            if (!show) {
              self._winningsPanel.visible = false;
            }
            callback();
          }
        );
      } else {
        callback();
      }
    }

    onfireballLinkEndEvent(task) {
      task.join();
      const self = this;
      this._endEvent = task;

      this._endTaskWinnings = task.data.winAmount;
      this.events = task.data.endGameEvents;
      this.eventIndex = 0;
      gameController.stormlinkWinnings = task.data.winAmount;

      timerManager.stop(this._reelsTimer);

      this.events = task.data.endGameEvents;
      this.eventIndex = 0;

      this._reelsTimer = undefined;

      this.afterEventsProcessedCallback = this.onFirelinkEndCallback.bind(this);

      timerManager.addTimeout(1000, function () {
        this.spinning = false;
        self.processEvents();
      });

      messageBus.post("spinner:stormLinkEnd");

      this._winnings = 0;
    }

    onFirelinkEndCallback() {
      this.doEndWinSequencePopUp();
    }

    doBigWin() {
      //this.endFeature();
    }

    doBlazingMultiplierPopup(callback) {
      const self = this;
      const OffScreenXPos = -780;

      this.blazingLogo.visible = true;
      this.multiplierLogo.visible = true;
      this.multiplierContainer.visible = false;
      this.blazingEndSequence.visible = true;

      this.blazingLogo.position.x = OffScreenXPos;
      this.multiplierLogo.position.x = OffScreenXPos;
      const resetMultiplierY = this.multiplierLogo.position.y;
      const resetBlazingLogoY = this.blazingLogo.position.y;
      this.multiplierValue.setText(
        "X" + gameController.currentBlazingMultiplier
      );
      this.dimReels.visible = true;

      gsap.to(this.dimReels, {
        duration: 0.2,
        ease: "power1.inOut",
        alpha: 0.8,
      });

      gsap.to(this.blazingEndSequence, {
        duration: 0.2,
        ease: "power1.inOut",
        alpha: 1,
      });

      gsap
        .timeline()
        .to(this.blazingLogo, {
          duration: 0.3,
          ease: "power1.out",
          x: 94,
          onComplete: () => {
            this.blazingMovie.gotoAndStop(0);
            this.blazingMovie.onComplete = () => {
              self.blazingMovie.visible = false;
            };
            this.blazingMovie.play();
            gsap
              .timeline()
              .to(this.blazingLogo, {
                duration: 0.4,
                ease: "power1.inOut",
                y: this.blazingLogo.position.y + 7,
              })
              .to(this.blazingLogo, {
                duration: 0.4,
                ease: "power1.inOut",
                y: this.blazingLogo.position.y - 14,
              })
              .to(this.blazingLogo, {
                duration: 0.4,
                ease: "power1.inOut",
                y: resetBlazingLogoY,
              });
          },
        })
        .to(this.multiplierLogo, {
          duration: 0.3,
          ease: "power1.out",
          x: 0,
          onComplete: () => {
            this.multiplierMovie.gotoAndStop(0);
            this.multiplierMovie.onComplete = () => {
              self.multiplierMovie.visible = false;
            };
            this.multiplierMovie.play();
            //callback();
            this.multiplierContainer.visible = true;
            this.multiplierContainer.scale = { x: 0, y: 0 };

            gsap
              .timeline()
              .to(this.multiplierLogo, {
                duration: 0.4,
                ease: "power1.inOut",
                y: this.multiplierLogo.position.y + 7,
              })
              .to(this.multiplierLogo, {
                duration: 0.4,
                ease: "power1.inOut",
                y: this.multiplierLogo.position.y - 14,
              })
              .to(this.multiplierLogo, {
                duration: 0.4,
                ease: "power1.inOut",
                y: resetMultiplierY,
              });
          },
        })
        .to(this.multiplierContainer.scale, {
          duration: 0.3,
          ease: "bounce.out",
          x: 1,
          y: 1,
          onComplete: () => {
            //callback();
            gsap.to(this.blazingEndSequence, {
              duration: 0.4,
              ease: "power1.inOut",
              alpha: 0,
              onComplete: () => {
                this.blazingEndSequence.alpha = 1;
                this.blazingEndSequence.visible = false;
                this.dimReels.visible = false;
                callback();
              },
            });
          },
        });
    }

    doBlazingBountyPopup(callback) {
      const self = this;
      soundManager.play("blazingBountyTextSound");
      const OffScreenXPos = -780;

      this.blazingLogo.visible = true;
      this.multiplierLogo.visible = true;
      this.multiplierContainer.visible = false;
      this.blazingEndSequence.visible = true;

      this.blazingLogo.position.x = OffScreenXPos;
      this.blazingLogo.position.y = this._blazingLogoPosition.midY;
      this.multiplierLogo.position.x = OffScreenXPos;
      const resetBlazingLogoY = this._blazingLogoPosition.midY;
      this.dimReels.visible = true;

      gsap.to(this.dimReels, {
        duration: 0.2,
        ease: "power1.inOut",
        alpha: 0.8,
      });

      gsap.to(this.blazingEndSequence, {
        duration: 0.2,
        ease: "power1.inOut",
        alpha: 1,
      });

      gsap
        .timeline()
        .to(this.blazingLogo, {
          duration: 0.3,
          ease: "power1.out",
          x: 94,
          onComplete: () => {
            this.blazingMovie.visible = true;
            this.blazingMovie.gotoAndStop(0);
            this.blazingMovie.onComplete = () => {
              self.blazingMovie.visible = false;
            };
            this.blazingMovie.play();
          },
        })
        .to(this.blazingLogo, {
          duration: 0.4,
          ease: "power1.inOut",
          y: this.blazingLogo.position.y + 7,
        })
        .to(this.blazingLogo, {
          duration: 0.4,
          ease: "power1.inOut",
          y: this.blazingLogo.position.y - 14,
        })
        .to(this.blazingEndSequence, {
          duration: 0.4,
          ease: "power1.inOut",
          alpha: 0,
          onComplete: () => {
            this.blazingEndSequence.alpha = 1;
            this.blazingEndSequence.visible = false;
            this.dimReels.visible = false;
            callback();
          },
        })
        .to(this.blazingLogo, {
          duration: 0.4,
          ease: "power1.inOut",
          y: resetBlazingLogoY,
        });
    }

    doBlazingMultiplierPopup(callback) {
      const self = this;
      const OffScreenXPos = -780;
      soundManager.play("blazingBountyMultiplier");
      this.blazingLogo.visible = true;
      this.multiplierLogo.visible = true;
      this.multiplierContainer.visible = false;
      this.blazingEndSequence.visible = true;

      this.blazingLogo.position.x = OffScreenXPos;
      this.multiplierLogo.position.x = OffScreenXPos;
      const resetMultiplierY = this.multiplierLogo.position.y;
      this.blazingLogo.position.y = this._blazingLogoPosition.topY;
      const resetBlazingLogoY = this.blazingLogo.position.y;
      this.multiplierValue.setText(
        "X" + gameController.currentBlazingMultiplier
      );
      this.dimReels.visible = true;

      gsap.to(this.dimReels, {
        duration: 0.2,
        ease: "power1.inOut",
        alpha: 0.8,
      });

      gsap.to(this.blazingEndSequence, {
        duration: 0.2,
        ease: "power1.inOut",
        alpha: 1,
      });

      gsap
        .timeline()
        .to(this.blazingLogo, {
          duration: 0.3,
          ease: "power1.out",
          x: 94,
          onComplete: () => {
            this.blazingMovie.gotoAndStop(0);
            this.blazingMovie.onComplete = () => {
              self.blazingMovie.visible = false;
            };
            this.blazingMovie.play();
            gsap
              .timeline()
              .to(this.blazingLogo, {
                duration: 0.4,
                ease: "power1.inOut",
                y: this.blazingLogo.position.y + 7,
              })
              .to(this.blazingLogo, {
                duration: 0.4,
                ease: "power1.inOut",
                y: this.blazingLogo.position.y - 14,
              })
              .to(this.blazingLogo, {
                duration: 0.4,
                ease: "power1.inOut",
                y: resetBlazingLogoY,
              });
          },
        })
        .to(this.multiplierLogo, {
          duration: 0.3,
          ease: "power1.out",
          x: 0,
          onComplete: () => {
            this.multiplierMovie.gotoAndStop(0);
            this.multiplierMovie.onComplete = () => {
              self.multiplierMovie.visible = false;
            };
            this.multiplierMovie.play();
            //callback();
            this.multiplierContainer.visible = true;
            this.multiplierContainer.scale = { x: 0, y: 0 };

            gsap
              .timeline()
              .to(this.multiplierLogo, {
                duration: 0.4,
                ease: "power1.inOut",
                y: this.multiplierLogo.position.y + 7,
              })
              .to(this.multiplierLogo, {
                duration: 0.4,
                ease: "power1.inOut",
                y: this.multiplierLogo.position.y - 14,
              })
              .to(this.multiplierLogo, {
                duration: 0.4,
                ease: "power1.inOut",
                y: resetMultiplierY,
              });
          },
        })
        .to(this.multiplierContainer.scale, {
          duration: 0.3,
          ease: "bounce.out",
          x: 1,
          y: 1,
          onComplete: () => {},
        })
        .to(this.blazingEndSequence, {
          delay: 2.5,
          duration: 0.4,
          ease: "power1.inOut",
          alpha: 0,
          onComplete: () => {
            this.blazingEndSequence.alpha = 1;
            this.blazingEndSequence.visible = false;
            this.dimReels.visible = false;
            callback();
          },
        });
    }

    doEndWinSequencePopUp() {
      const self = this;
      gameData.musicManager.fadeOutAllMusic();
      soundManager.play("fireBallOutro");
      this.endingWinValueContainer.visible = false;
      this.endingWinSequence.visible = true;
      this.endingWinSequence.alpha = 0;
      this.endingWinValueContainer.scale = {
        x: 0,
        y: 0,
      };
      this.endingWinValue.setText(
        gdk.formatCurrency(self._winnings).replace("X", "")
      );
      this.dimReels.visible = true;

      gsap.to(this.dimReels, {
        duration: 0.3,
        ease: "power1.inOut",
        alpha: 0.8,
      });

      gsap.to(this.endingWinSequence, {
        duration: 0.4,
        ease: "power1.inOut",
        alpha: 1,
      });

      gsap
        .timeline()
        .to(this.endingWinValueContainer.scale, {
          duration: 0.5,
          ease: "bounce.out",
          x: 0,
          y: 0,
          onComplete: () => {
            this.endingWinValueContainer.visible = true;
          },
        })
        .to(this.endingWinValueContainer.scale, {
          duration: 0.3,
          ease: "bounce.out",
          x: 1,
          y: 1,
          onComplete: () => {
            gsap
              .timeline()
              .to(this.endingWinValueContainer.scale, {
                duration: 0.5,
                ease: "bounce.out",
                x: 1,
                y: 1,
              })
              .to(this.endingWinSequence, {
                delay: 4,
                duration: 0.4,
                ease: "power1.inOut",
                alpha: 0,
                onComplete: () => {
                  this.endingWinSequence.alpha = 1;
                  this.endingWinSequence.visible = false;
                  this.dimReels.visible = false;
                  self.endFeature();
                },
              });
          },
        });
    }

    processMultipliers(callback) {
      if (this._skipped) {
        callback();
      } else {
        this._currentPrizeIndex = 0;
        this._countMultipliersStarted = 0;
        this.processNextMultiplier(callback);
      }
    }

    processNextMultiplier(callback) {
      if (this._multipliers.length === 0) {
        callback();
      } else {
        if (this._currentPrizeIndex < this._multipliers.length) {
          const self = this;
          ++this._countMultipliersStarted;
          this.processMultiplier(
            this._multipliers[this._currentPrizeIndex],
            function () {
              self._currentPrizeIndex++;

              if (self._countMultipliersStarted < self._multipliers.length) {
                timerManager.addTimeout(1000, function () {
                  self.processNextMultiplier(callback);
                });
              }

              if (self._currentPrizeIndex >= self._multipliers.length) {
                callback();
              }
            }
          );
        }
      }
    }

    processMultiplier(prize, callback) {
      const reel = prize.reel;
      const row = prize.row;

      const text = this._reelPrizeObjects[reel][row].text;
      text.setText("X" + prize.prizeData.value);
      text.visible = true;
      const container = this._reelPrizeObjects[reel][row].container;
      const self = this;

      this.toggleOverlay(false, reel, row);

      this.collectPrize(container, reel, row, function () {
        text.visible = false;
        self.toggleOverlay(true, reel, row);
        self.countUpPrize(
          self._winnings * prize.prizeData.value - self._winnings,
          function () {
            if (callback) {
              callback();
            }
          },
          1000
        );
      });
    }

    processPrizes(callback) {
      this._multipliers = [];
      this._currentPrizeIndex = 0;

      gameData.musicManager.fadeFireballMusicOff();

      gameController.stormLinkPayout = true;

      if (this._megaPotWon) {
        const self = this;
        this.doFullFireballCelebration(function () {
          self.sortPrizes();
          self.processNextPrize(callback);
        });
      } else {
        if (this._skipped) {
          this.sortPrizes();
          this.skipped(callback);
        } else {
          this.sortPrizes();
          this.processNextPrize(callback);
        }
      }
    }

    processNextPrize(callback) {
      if (this._skipped) {
        this.skipped(callback);
        return;
      }
      if (this._currentPrizeIndex < this._prizes.length) {
        let prizeType = this._prizes[this._currentPrizeIndex].prizeData.type;
        this.processPrize(
          this._prizes[this._currentPrizeIndex++],
          function () {}
        );

        // remove delay when we encounter a multiplier
        if (prizeType === "Multiplier" || prizeType === "WildMultiplier") {
          this.processNextPrize(callback);
        } else {
          const self = this;
          timerManager.addTimeout(800, function () {
            self.processNextPrize(callback);
          });
        }
      } else {
        callback();
      }
    }

    processPrize(prize, callback) {
      const reel = prize.reel;
      const row = prize.row;

      switch (prize.prizeData.type) {
        case "Cash":
        case "WildCash": {
          const text = this._reelPrizeObjects[reel][row].text;
          text.setText(
            PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
              prize.prizeData.value / 100
            )
          );
          text.visible = true;
          const container = this._reelPrizeObjects[reel][row].container;

          this.toggleOverlay(false, reel, row);

          const self = this;
          this.collectPrize(container, reel, row, function () {
            self.toggleOverlay(true, reel, row);
            text.visible = false;
            self.countUpPrize(prize.prizeData.value, function () {
              callback();
            });
          });
          break;
        }
        case "Pot":
        case "WildPot": {
          this.processPotPrize(prize, callback);
          break;
        }
        case "Multiplier":
        case "WildMultiplier": {
          this._multipliers.push(prize);
          callback();
          break;
        }
      }
    }

    processPotPrize(prize, callback) {
      const reel = prize.reel;
      const row = prize.row;

      let sprite = undefined;
      let sprite_double = undefined;
      let pot = undefined;

      switch (prize.prizeData.potName) {
        case "Mini": {
          sprite = this._reelPrizeObjects[reel][row].mini;
          sprite_double = this._reelPrizeObjects[reel][row].mini_double;
          pot = resourceManager.get("potContainer:mini");
          break;
        }
        case "Minor": {
          sprite = this._reelPrizeObjects[reel][row].minor;
          sprite_double = this._reelPrizeObjects[reel][row].minor_double;
          pot = resourceManager.get("potContainer:minor");
          break;
        }
        case "Major": {
          sprite = this._reelPrizeObjects[reel][row].major;
          sprite_double = this._reelPrizeObjects[reel][row].major_double;
          pot = resourceManager.get("potContainer:major");
          break;
        }
        case "Mega": {
          sprite = this._reelPrizeObjects[reel][row].mega;
          sprite_double = this._reelPrizeObjects[reel][row].mega_double;
          pot = resourceManager.get("potContainer:mega");
          break;
        }
      }

      sprite.visible = true;

      // bounce pot value on pot panel
      timerManager.addTimer(
        250,
        function (progress) {
          let newScale = 1 + 0.3 * Math.abs(Math.sin(Math.PI * progress));
          pot.scale.set(newScale, newScale);
        },
        function () {
          pot.scale.set(1, 1);
        }
      );

      if (prize.prizeData.isDoubled) {
        sprite.position.setY(sprite.position.getY() - 25);
        sprite_double.visible = true;
      }

      const container = this._reelPrizeObjects[reel][row].container;

      this.toggleOverlay(false, reel, row);

      const self = this;
      this.collectPrize(container, reel, row, function () {
        self.toggleOverlay(true, reel, row);
        sprite.visible = false;
        if (prize.prizeData.isDoubled) {
          sprite.position.setY(sprite.position.getY() + 25);
          sprite_double.visible = false;
        }
        self.countUpPrize(prize.prizeData.value, callback);
      });
    }

    endFeature() {
      const self = this;
      this._megaPotWon = false;
      soundManager.stop("fireballEndCountLoop");
      this.infoPanel.visible = false;
      gameController.wildLandAnimator.visible = true;

      this._fblLogo.visible = false;
      this._reelFrame.visible = false;
      gameController.baseReelFrame.visible = true;

      gameController.volcano.setSkin("Day");
      soundManager.play("multiplierLock");
      gameController.padlock.play("Padlock_Relock", false, 0, undefined);

      if (!this._inFS) {
        this._logo.visible = true;
        this._logo.alpha = 0;

        gsap.to(this._logo, {
          duration: 0.3,
          alpha: 1,
        });
      }
      this.blazingZone0.visible = false;
      this.blazingZoneLoop0.visible = false;
      this.blazingZoneGrow0.visible = false;
      this.blazingZone1.visible = false;
      this.blazingZoneLoop1.visible = false;
      this.blazingZoneGrow1.visible = false;
      this.blazingZone2.visible = false;
      this.blazingZoneLoop2.visible = false;
      this.blazingZoneGrow2.visible = false;
      this.blazingZone3.visible = false;
      this.blazingZoneLoop3.visible = false;
      this.blazingZoneGrow3.visible = false;
      this.blazingZone4.visible = false;
      this.blazingZoneLoop4.visible = false;
      this.blazingZoneGrow4.visible = false;
      this.blazingZone5.visible = false;
      this.blazingZoneLoop5.visible = false;
      this.blazingZoneGrow5.visible = false;

      for (let reel = 0; reel < gameData.numReels; reel++) {
        const firstChild = resourceManager.get(
          `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${reel}:reel${
            reel * gameData.numRows
          }`
        );
        firstChild.useRegularMask();
      }

      gameController.stormLinkPayout = false;
      this._skipped = false;

      gameController.winningsContainer.visible = true;

      gameData.winningsMeter.add(this._endTaskWinnings);

      for (let i = 0; i < this._slotMachine._reelVisuals.length; i++) {
        this._slotMachine._reelVisuals[i].suspendUpdates();
      }
      for (let i = 0; i < gameController.slotMachine._reelVisuals.length; i++) {
        gameController.slotMachine._reelVisuals[i].clearSuspendUpdates();
      }

      this._currentSpinPositions.forEach(function (position, id) {
        const reel = Math.floor(id / gameData.numRows);
        const row = id % gameData.numRows;
        gameData.reels[reel].setReelSymbol(row, position[0]);

        const onBaseGameReelsFireBallText = resourceManager.get(
          `slotContainer:reelContainer:reel${reel}:symbol${row}:symbol_standard:childContainer:fireballCashOverlay`
        );
        const onReelsFireballText = resourceManager.get(
          `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${reel}:reel${id}:symbol${0}:symbol:childContainer:fireballCashOverlay`
        );
        onBaseGameReelsFireBallText.modifiedValue =
          onReelsFireballText.modifiedValue;

        onReelsFireballText.modifiedValue = undefined;

        resourceManager.get("slotContainer:jackpotReelsLogo").visible = true;
        resourceManager.get("slotContainer:triggeredByVolcano").visible = true;
      });

      for (let reel = 0; reel < 6; ++reel) {
        gameData.reels[reel]._lockedCashValues = false;
        gameData.reels[reel].redraw();
      }

      timerManager.addDelayedTimer(
        1000,
        500,
        function (progress) {
          self._winningsPanel.alpha = 1 - progress;
        },
        function () {
          self._winningsPanel.alpha = 1;
          self._winningsPanel.visible = false;

          resourceManager.get("slotContainer:reelContainer").visible = true;

          //this._winlinesTab.visible = true;

          // maybe not if in freespins or if we have a pot bonus
          if (
            gameController.inFreeSpins === false &&
            gameController.isPotBonus === null
          ) {
            self._linkBG.visible = false;
            self._linkBGPortrait.visible = false;
          }

          gameData.reels.forEach(function (reel) {
            reel.lockFireballCashValues(true);
          });
          gameController.isInFeature = false;
          self._slotMachine.clearDimSymbolIds();

          self.visible = false;
          self._endEvent.leave();
          self._endEvent = undefined;
          self._active = false;
        }
      );
    }

    onFreespinsStart() {
      this._inFS = true;
    }

    onFreespinsEndEvent() {
      this._inFS = false;
    }

    skip() {
      this._skipped = true;
    }
  }

  function convertIndexToReelRow(index) {
    const rows = 3;
    const reel = Math.floor(index / rows);
    const row = index % rows;
    return { reel, row };
  }

  function convertReelRowToIndex(reel, row) {
    const rows = 3; // Number of rows
    return reel * rows + row;
  }

  var firelinkFeatureCreator = function (json) {
    return new FirelinkFeature();
  };

  var firelinkFeatureInitialiser = function (json, firelinkFeature) {};

  var firelinkFeatureFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "firelinkFeature",
    firelinkFeatureCreator,
    firelinkFeatureInitialiser,
    firelinkFeatureFilesRequired
  );
})();
